<template>

  <div class="preview-screenshot-multiple" v-if="page.network === 'instagram' && post.previewStoryMultipleScreenshotVideo">
    <video :src="post.previewStoryMultipleScreenshotVideo" crossorigin="anonymous" controls></video>
  </div>
  <div class="preview-screenshot-multiple" v-else-if="page.network === 'instagram' && post.previewStoryMultipleScreenshot">
    <img :src="post.previewStoryMultipleScreenshot" alt=""/>
  </div>
  
  

  <div class="template-preview" v-else-if="page.network === 'instagram' 
                                          && post._bots && post._bots.mode === 'story' 
                                          && post._bots.page && post._bots.page.story_config 
                                          && post._bots.page.story_config.created && post.status === 'preview' 
                                          && post._bots.storyTemplate && post._bots.storyTemplate.predefined"
  >
    <img class="template-img" :src="meta.og.images[0].url" alt="" @error="replaceByDefault">
    <img :src="`https://s3.eu-west-1.amazonaws.com/saas.mashup/static-assets/${post._bots.storyTemplate.predefined}.png`" alt="" @error="replaceByDefault">
    <p>{{post.title}}</p>
    <a :href="post.url" target="_blank" class="link-container-2"> 
      <img class="link-img-2" src="../../assets/img/icon_instagram_link.svg" alt="Link">
      <p class="link-txt-2">{{post.url.split('/')[2].toUpperCase()}}</p>
    </a>
  </div>

  <component-template-maker 
      v-else-if="page.network === 'instagram' && post.status === 'preview' && !(post.screenshot || (post.page && post.page[0] && (post.page[0].story || post.page[0].story_standard_api) && JSON.parse(post.page[0].story).screenshot)) 
                    && ((post._bots && post._bots[0] && post._bots[0].mode === 'story' 
                    && post._bots[0].page && post._bots[0].page.story_config && post._bots[0].page.story_config.created) 
                    || (post._bots && post._bots.mode === 'story' 
                    && post._bots.page && post._bots.page.story_config && post._bots.page.story_config.created) 
                    || (bot && bot.page && bot.mode === 'story' && bot.page.story_config 
                    && bot.page.story_config.created)) && ((post.page && post.page[0] && (post.page[0].story || post.page[0].story_standard_api) && post.status === 'scheduled') || ['preview', 'draft'].includes(post.status)) && (post.enclosure || (meta && meta.og && meta.og.images[0] && meta.og.images[0].url))" 
      :configuration="post._bots[0] && post._bots[0].storyTemplate ? post._bots[0].storyTemplate.configuration : (post._bots && post._bots.storyTemplate ? post._bots.storyTemplate.configuration : bot.storyTemplate.configuration)" 
      :image="post.enclosure || meta.og.images[0].url" 
      :title="post.title" :link="post.url || null" 
      :preview="true"
  ></component-template-maker>

  <div class="preview-post-story" v-else-if="['instagram', 'facebook'].includes(page.network) && ((post.page && post.page[0] && (post.page[0].story || post.page[0].story_standard_api)) || post.screenshot)">
    <div class="user-info-story">
      <a :href="getPageUrl || null" target="blank" :class="!getPageUrl && 'black-text'">
        <page-image-avatar :page="page"/>
        <span>{{page.name}}</span>
      </a>
      <span>{{dateFormat(postDate, true)}}</span>
    </div>
    <!-- <a :href="post.url" target="_blank"> -->
      <story :class="!live && 'storification-preview-size'"
          :story="!(storificationObject || shareAfterPostPreview) ? {
            image: imageStory,
            video: videoStory
          } : undefined"
          :storification="(storificationObject || shareAfterPostPreview) ? {
            image: (carouselData && carouselData[0] && carouselData[0].url) || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: storificationObject ? storificationObject.username : page.name,
            isCarousel: storificationObject ? storificationObject.isCarousel : (multipleImages && multipleImages.length > 1) || (carouselData && carouselData.length > 1),
            video: videoStory || post.video || (post.page && post.page[0] && post.page[0].video || (post.videos && post.videos['instagram_reel'])),
            widgetsReel: {
              texts: $store.getters.storificationTextsReel,
              gifs: $store.getters.storificationGifsReel,
              music: $store.getters.storificationMusicReel
            }
          } : undefined"
          :backgroundColor="$store.getters.storificationBackgroundColor"
          :link="{
            url: post.url,
            initialDatas: $store.getters.storificationLink,
            isActive: $store.getters.storificationLinkIsActive,
            text: $store.getters.storificationLinkText,
          }"
          :texts="$store.getters.storificationTexts"
          :layers="$store.getters.storificationLayers"
          :gifs="$store.getters.storificationGifs"
          :music="$store.getters.storificationMusic"
          :poll="$store.getters.storificationPoll"
          :slider="$store.getters.storificationSlider"
          :location="$store.getters.storificationLocation"
          :product="$store.getters.storificationProduct"
          :mentions="$store.getters.storificationMentions"
          :hashtags="$store.getters.storificationHashtags"
          :question="$store.getters.storificationQuestion"
          :template="{
            config: $store.getters.storificationTemplate,
            custom: currentBot ? currentBot.storyTemplate : null
          }"
          :preview="live ? null : {
            'Link': $store.getters.storificationLink,
            'Text': $store.getters.storificationTexts,
            'Layer': $store.getters.storificationLayers,
            'Gif': $store.getters.storificationGifs,
            'Poll': $store.getters.storificationPoll,
            'Slider':$store.getters.storificationSlider,
            'Mention': $store.getters.storificationMentions,
            'Hashtag': $store.getters.storificationHashtags,
            'Location': $store.getters.storificationLocation,
            'Product': $store.getters.storificationProduct,
            'Question': $store.getters.storificationQuestion,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
    </story>
      <!-- <storification v-if="post.page[0].storification && typePost !== 'story'" class="storification-preview-size"
          :storification="{
            image: (post.page[0].carousel && post.page[0].carousel[0] && post.page[0].carousel[0].url) || post.page[0].enclosure || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: page.name,
            isCarousel: post.page[0].carousel && post.page[0].carousel.length > 1
          }"
          :link="{
            url: post.url,
            initialDatas: (post.draft && post.draft.data.storificationData.link) || (post.page[0].storificationData && post.page[0].storificationData.link),
            isActive: (post.draft && post.draft.data.storificationData.link.active) || (post.page[0].storificationData && post.page[0].storificationData.link && post.page[0].storificationData.link.active),
            text: (post.draft && post.draft.data.storificationData.link.text) || (post.page[0].storificationData && post.page[0].storificationData.link && post.page[0].storificationData.link.text)
          }"
          :preview="live ? null : {
            'Link': (post.draft && post.draft.data.storificationData.link) || (post.page[0].storificationData && post.page[0].storificationData.link)
          }"
          >
      </storification>
      <video v-else-if="post.page[0] && post.page[0].story && typeof post.page[0].story === 'string' && JSON.parse(post.page[0].story).texts[0] && JSON.parse(post.page[0].story).texts[0].music && post.page[0].video" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls />
      <video v-else-if="post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].enclosure" controls />
      <video v-else-if="post.page[0] && post.page[0].video && post.page[0].video.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls />
      <img v-else :src="post.screenshot || JSON.parse(post.page[0].story).screenshot || post.page[0].enclosure" alt="preview" @error="replaceByDefault"> -->
      <!-- <div v-if="post.page[0].storification && typePost !== 'story'" class="preview-share-after-post background-img">
        <img crossorigin="anonymous" v-if="post.page[0].enclosure" class="share-img" :src="post.page[0].enclosure + `?timestamp=${new Date().getTime()}`" alt="iii" @load="shareLoadImage" @error="shareLoadErrorImage">
        <img class="share-img" v-else-if="meta && meta.og && meta.og.image" :src="meta.og.image" @load="shareLoadImage"/>
        <img class="share-img" v-else-if="meta && meta.og && meta.og.images && meta.og.images[0] && meta.og.images[0].url" :src="meta.og.images[0].url" @load="shareLoadImage"/>
        <img class="share-img" v-else-if="meta && meta.images && meta.images[0] && meta.images[0].url" :src="meta.images[0].url" @load="shareLoadImage"/>
        <img class="share-img" v-else-if="post.enclosure" :src="post.enclosure" @load="shareLoadImage"/>
        <p class="share-username">@{{page.name}}</p>
        <img :hidden="!post.page[0].carousel || post.page[0].carousel.length <= 1" class="carousel-storification" src="../../assets/img/carousel.svg"/>
      </div>
      <video v-else-if="post.page[0] && post.page[0].story && typeof post.page[0].story === 'string' && JSON.parse(post.page[0].story).texts[0] && JSON.parse(post.page[0].story).texts[0].music && post.page[0].video" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls />
      <video v-else-if="post.page[0] && post.page[0].enclosure && post.page[0].enclosure.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].enclosure" controls />
      <video v-else-if="post.page[0] && post.page[0].video && post.page[0].video.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls />
      <img v-else :src="post.screenshot || JSON.parse(post.page[0].story).screenshot || post.page[0].enclosure" alt="preview" @error="replaceByDefault"> -->
    <!-- </a> -->
  </div>

  <div class="preview-post-story" v-else-if="page.network === 'facebook' && ((post.page && post.page[0] && (post.page[0].story || post.page[0].story_standard_api)))">
    <div class="user-info-story">
      <a :href="getPageUrl || null" target="blank" :class="!getPageUrl && 'black-text'">
        <page-image-avatar :page="page"/>
        <span>{{page.name}}</span>
      </a>
      <span>{{dateFormat(postDate, true)}}</span>
    </div>
    <!-- <a :href="post.url" target="_blank"> -->
      <storification v-if="post.page[0].storification && typePost !== 'story'" class="storification-preview-size"
          :storification="{
            image: (post.page[0].carousel && post.page[0].carousel[0] && post.page[0].carousel[0].url) || post.page[0].enclosure || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: page.name,
            isCarousel: post.page[0].carousel && post.page[0].carousel.length > 1,
          }"
          :link="{
            url: post.url,
            initialDatas: (post.draft && post.draft.data.storificationData.link) || (post.page[0].storificationData && post.page[0].storificationData.link),
            isActive: (post.draft && post.draft.data.storificationData.link.active) || (post.page[0].storificationData && post.page[0].storificationData.link && post.page[0].storificationData.link.active),
            text: (post.draft && post.draft.data.storificationData.link.text) || (post.page[0].storificationData && post.page[0].storificationData.link && post.page[0].storificationData.link.text)
          }"
          :preview="live ? null : {
            'Link': (post.draft && post.draft.data.storificationData.link) || (post.page[0].storificationData && post.page[0].storificationData.link),
            'Text': (post.draft && post.draft.data.storificationData.texts) || (post.page[0].storificationData && post.page[0].storificationData.texts),
            'Layer':(post.draft && post.draft.data.storificationData.layers) || (post.page[0].storificationData && post.page[0].storificationData.layers),
            'Gif': (post.draft && post.draft.data.storificationData.gifs) || (post.page[0].storificationData && post.page[0].storificationData.gifs),
            'Poll': (post.draft && post.draft.data.storificationData.poll) || (post.page[0].storificationData && post.page[0].storificationData.poll),
            'Slider':(post.draft && post.draft.data.storificationData.mentions) || (post.page[0].storificationData && post.page[0].storificationData.slider),
            'Mention': (post.draft && post.draft.data.storificationData.mentions) || (post.page[0].storificationData && post.page[0].storificationData.mentions),
          }"
          >
      </storification>
      <video v-else-if="post.page[0] && post.page[0].story && typeof post.page[0].story === 'string' && JSON.parse(post.page[0].story).texts[0] && JSON.parse(post.page[0].story).texts[0].music && post.page[0].video" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls/>
      <video v-else-if="post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].enclosure" controls/>
      <video v-else-if="post.page[0] && post.page[0].video && post.page[0].video.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls/>
      <img v-else :src="post.screenshot || JSON.parse(post.page[0].story).screenshot || post.page[0].enclosure" alt="preview" @error="replaceByDefault">
      <!-- <div v-if="post.page[0].storification" class="preview-share-after-post background-img">
        <img crossorigin="anonymous" v-if="post.page[0].enclosure" class="share-img" :src="post.page[0].enclosure  + `?timestamp=${new Date().getTime()}`" alt="aaaa" @load="shareLoadImage" @error="shareLoadErrorImage">
        <img class="share-img" v-else-if="meta && meta.og && meta.og.image" :src="meta.og.image" @load="shareLoadImage"/>
        <img class="share-img" v-else-if="meta && meta.og && meta.og.images && meta.og.images[0] && meta.og.images[0].url" :src="meta.og.images[0].url" @load="shareLoadImage"/>
        <img class="share-img" v-else-if="meta && meta.images && meta.images[0] && meta.images[0].url" :src="meta.images[0].url" @load="shareLoadImage"/>
        <img class="share-img" v-else-if="post.enclosure" :src="post.enclosure" @load="shareLoadImage"/>
        <p class="share-username">@{{page.name}}</p>
        <img :hidden="!post.page[0].carousel || post.page[0].carousel.length <= 1" class="carousel-storification" src="../../assets/img/carousel.svg"/>
      </div>
      <video v-else-if="post.page[0] && post.page[0].story && typeof post.page[0].story === 'string' && JSON.parse(post.page[0].story).texts[0] && JSON.parse(post.page[0].story).texts[0].music && post.page[0].video" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls />
      <video v-else-if="post.page[0] && post.page[0].enclosure && post.page[0].enclosure.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].enclosure" controls />
      <video v-else-if="post.page[0] && post.page[0].video && post.page[0].video.slice(-4) === '.mp4'" class="ratio story-video" @loadedmetadata="videoRatio" :src="post.page[0].video" controls />
      <img v-else :src="post.page[0].screenshot || post.page[0].enclosure" alt="preview" @error="replaceByDefault"> -->
    <!-- </a> -->
  </div>

  <div class="tiktok-video-container" v-else-if="(page.network === 'tiktok')" @click="getTiktokPageUrl(page.id)">
    <div class="tiktok-video-screen">
      <span class="tiktok-username">{{`@${page.name}`}}</span>
      <div class="tiktok-categories">
        <span>Following</span>
        <span>For You</span>
      </div>
      <div class="tiktok-buttons">
        <vs-avatar class="tiktok-avatar" size="50px" :src="page.avatar" alt="page"/>
        <img src="../../assets/img/tiktok-iconbar.svg" alt="">
        <vs-avatar class="tiktok-avatar-music" size="28px" :src="page.avatar" alt="page"/>
      </div>
      <div class="tiktok-video" v-if="post.videos && post.videos['tiktok']">
        <video loop controls crossorigin="anonymous" class="ratio" @loadedmetadata="videoRatio" :src="post.videos['tiktok']"/>
      </div>
      <div class="tiktok-video" v-if="post.video && typeof post.video === 'string' && post.video.includes('http')">
        <video loop controls crossorigin="anonymous" class="ratio" @loadedmetadata="videoRatio" :src="post.video"/>
      </div>
      <div class="tiktok-video" v-else-if="post.page && post.page[0] && post.page[0].video">
        <video loop controls crossorigin="anonymous" class="ratio" @loadedmetadata="videoRatio" :src="post.page[0].video"/>
      </div>
      <div v-else class="tiktok-video no">
        {{$t('dash.message.no.video')}}
      </div>
    </div>
  </div>

  <div class="reel-container" :class="[{'lorem' : post.title == '' && !moderation, live }]" v-else-if="page.network === 'instagram' && (typePost == 'video' || (post.page && post.page[0] && post.page[0].video)) && (videoReel || post.videoReel || (post.page && post.page[0] && post.page[0].videoReel))">
    <p class="date" v-if="moderation && !['telegram'].includes(page.network)" @click.prevent="live && !activeEdit.scheduling && isUserPremiumActive ? showEditPost('scheduling') : null">
      <Tooltip
        :text="dateFormat(post.date)"
        position="top"
      >
        <span>{{ dateFromNow(post.date) }}</span>
        &nbsp;
      </Tooltip>
    </p>
    <p class="date" v-else-if="!['telegram'].includes(page.network)">
      {{ postDate }}
      <span class="btn-edit" v-if="live && !doScreenshot">
        <Tooltip
          :text="$t('dash.post.overlay.edit.date')"
          position="top"
        >
          <vs-button
            v-show="live && !activeEdit.scheduling && isUserPremiumActive"
            vs-type="filled"
            @click.prevent="showEditPost('scheduling')"
            icon="edit"
            class="button-reel-edit"
          ></vs-button>
          &nbsp;&nbsp;
        </Tooltip>
      </span>
    </p>
    <div v-if="live && activeEdit.scheduling && !['telegram'].includes(page.network)" class="live-scheduling schedule">
      <div class="schedule-wrapper">
        <div class="edit-scheduling">
          <component-datepicker
            class="posts-datepicker"
            v-on:picked="picked"
            :date="new Date(editValue.scheduling.date)"
            :now="true"
          ></component-datepicker>
          <div class="posts-timepicker">
            <img src="../../assets/img/icon_time_black.svg" alt="time">
            <vue-timepicker v-model="editValue.scheduling.time" :hour-range="rangeHour" :minute-range="rangeMinute" @change="changeRangeSchedulingTime" auto-scroll :minute-interval="minuteInterval"></vue-timepicker>
          </div>
          <vs-button
            vs-type="filled"
            @click.prevent="activeEdit.scheduling = false"
            icon="close"
          ></vs-button>
          <vs-button
            vs-type="filled"
            @click.prevent="editPost('scheduling')"
            icon="check"
          ></vs-button>
        </div>
      </div>
    </div>
    <div class="reel" :class="!live && 'storification-preview-size'" v-if="(post.video && typeof post.video === 'string' && post.video.includes('http')) || (post.page && post.page[0] && post.page[0].video) || (post.videos && post.videos['instagram_reel'])">
      <story
          :story="{
            video: videoStory,
            isReel: true,
            enclosure: ['instagram'].includes(page.network) && (image || (post.page && post.page[0] && post.page[0].enclosure)) ? (image || post.page[0].enclosure) : null
          }"
          :texts="$store.getters.storificationTextsReel"
          :gifs="$store.getters.storificationGifsReel"
          :music="$store.getters.storificationMusicReel"
          :preview="live ? null : {
            'Text': $store.getters.storificationTextsReel,
            'Gif': $store.getters.storificationGifsReel,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
      </story>
      <!-- <p class="reel-name">Reels</p> -->
      <div v-if="!($store.getters.storificationMusicReel && $store.getters.storificationMusicReel.config)" class="reel-cta">
        <div><svg aria-label="J’aime" class="_8-yf5 " fill="#FFF" height="24" viewBox="0 0 48 48" width="24"><path d="M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z"></path></svg></div>
        <div><svg aria-label="Commenter" class="_8-yf5 " fill="#FFF" height="24" viewBox="0 0 48 48" width="24"><path clip-rule="evenodd" d="M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z" fill-rule="evenodd"></path></svg></div>  
        <div><svg aria-label="Partager la publication" class="_8-yf5 " fill="#FFF" height="24" viewBox="0 0 48 48" width="24"><path d="M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z"></path></svg></div>
        <div>. . .</div>
      </div>
      <div v-if="!($store.getters.storificationMusicReel && $store.getters.storificationMusicReel.config)" class="reel-background"></div>
      <a v-if="!($store.getters.storificationMusicReel && $store.getters.storificationMusicReel.config)" class="reel-avatar" :href="getPageUrl || null" target="blank" :class="!getPageUrl && 'black-text'">
        <page-image-avatar :page="page"/>
        <p class="page-name">{{`${page.name}`}}</p><p class="reel-follow">Suivre</p>
      </a>
      <div v-if="!($store.getters.storificationMusicReel && $store.getters.storificationMusicReel.config)" class="title reel-title" :class="[{'lorem' : post.title == '' && !moderation, live }]">
          <div class="title-cont" v-if="!activeEdit.title" @click.prevent="live && !activeEdit.title ? showEditPost('title') : null">
            <span class="hashtag-prefix" v-if="activePrefixSuffix && bot && bot.hashtagPrefix && post.title != ''"
              v-html="`${addHashtagsLinks(bot.hashtagPrefix)} `"
            ></span>
            <span v-html="handleNewLine(getMessageToPost(post).slice(0, 80))"></span>{{getMessageToPost(post).length > 80 ? '...' : ''}}
            <span class="hashtag-suffix" v-if="activePrefixSuffix && bot && bot.hashtag && post.title != ''"
              v-html="` ${addHashtagsLinks(bot.hashtag)}`"
            ></span>
          </div>
          <div v-if="live && !doScreenshot && post.title != ''" class="live-title">
            <span class="btn-edit">
              <Tooltip
                :text="$t('dash.post.overlay.edit.message')"
                position="top"
              >
                <vs-button
                  class="button-reel-edit"
                  v-show="!activeEdit.title"
                  vs-type="filled"
                  @click.prevent="showEditPost('title')"
                  icon="edit"
                ></vs-button>
                &nbsp;&nbsp;
              </Tooltip>
            </span>
            <div class="edit-title" v-if="activeEdit.title">
              <div class="textarea-emoji-picker" v-click-outside="hideEmojiPicker">
                <div class="styles-text-buttons" v-if="page.network !== 'bluesky'">
                  <span @click="styleSelection('bold')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('bold') }">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#888888" d="M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z"/>
                    </svg>
                  </span>
                  <span @click="styleSelection('italic')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('italic') }">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#888888" d="M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z "/>
                    </svg>
                  </span>
                  <span @click="styleSelection('underline')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('underline') }">
                    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path fill="#888888" d="M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z"/>
                      <path fill="#888888" d="M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z"/>
                    </svg>
                  </span>
                </div>
                <picker
                  v-if="page.network !== 'bluesky'"
                  :data="emojiIndex"
                  v-show="showEmojiPicker"
                  title="Pick your emoji..."
                  emoji="point_up"
                  @select="addEmoji"
                />
                <span
                  v-if="page.network !== 'bluesky'"
                  class="emoji-trigger"
                  :class="{ 'triggered': showEmojiPicker }"
                  @click="toggleEmojiPicker"
                >
                  <svg
                    style="width:20px;height:20px"
                    viewBox="0 0 24 24"
                  >
                    <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                  </svg>
                </span>
                <span class="add-mention" @click="toggleShowMentions('Mention')">@</span>
                <span class="add-mention add-hashtag" @click="toggleShowMentions('Hashtag')" v-if="activeSearchHashtags">#</span>
                <span class="add-mention ai-generate" @click="getAccrochesByAI()"><span class="material-icons">lightbulb_outline</span></span>
                <vs-button
                  vs-type="filled"
                  @click.prevent="activeEdit.title = false"
                  icon="close"
                  class="close button-reel"
                ></vs-button>
                <vs-button
                  vs-type="filled"
                  @click.prevent="editPost('title')"
                  icon="check"
                  class="save button-reel"
                ></vs-button>
                <vs-textarea 
                  :class="{'input': true}"
                  vs-size="large"
                  color="#B20564"
                  name="title"
                  :placeholder="$t('dash.posts.overlay.description_placeholder')"
                  v-model="editValue.title"
                  :ref="`inputTitle-${page.network_id}`"
                  :id="`inputTitle-${page.network_id}`"
                  @click="[checkAddMention()]"
                  @keyup="[checkTruncate(), checkAddMention(), textAreaAdjust(`inputTitle-${page.network_id}`)]"
                /> 
                <div class="vs-textarea--count" v-if="limitText()">
                  {{ sizeCurrentMessage() }} / {{ limitText() }}
                </div>  
              </div>
            </div>
        </div>
      </div>
      <!-- <div class="post-image reel-video" v-else-if="post.videos && post.videos['instagram_reel']">
        <video controls :id="live ? `video-${page.id}` : ''" class="ratio" @loadedmetadata="videoRatio" :src="post.videos['instagram_reel']" :poster="(image || (post.page && post.page[0] && post.page[0].enclosure)) ? (image || post.page[0].enclosure) : null"/>
      </div>
      <div class="post-image reel-video" v-else-if="post.video && typeof post.video === 'string' && post.video.includes('http')">
        <video controls :id="live ? `video-${page.id}` : ''" class="ratio" @loadedmetadata="videoRatio" :src="post.video" :poster="(image || (post.page && post.page[0] && post.page[0].enclosure)) ? (image || post.page[0].enclosure) : null"/>
      </div>
      <div class="post-image reel-video" v-else-if="post.page && post.page[0] && post.page[0].video">
        <video controls :id="live ? `video-${page.id}` : ''" class="ratio" @loadedmetadata="videoRatio" :src="post.page[0].video" :poster="(image || (post.page && post.page[0] && post.page[0].enclosure)) ? (image || post.page[0].enclosure) : null"/>
      </div> -->
      
    </div>
    
    <div class="text-reel" v-if="(post.video && typeof post.video === 'string' && post.video.includes('http')) || (post.page && post.page[0] && post.page[0].video) || (post.videos && post.videos['instagram_reel'])">
      <!-- {{ post.title }} -->
      <div class="title-cont" v-if="!activeEdit.title" @click.prevent="live && !activeEdit.title ? showEditPost('title') : null">
        <span class="hashtag-prefix" v-if="activePrefixSuffix && bot && bot.hashtagPrefix && post.title != ''"
          v-html="`${addHashtagsLinks(bot.hashtagPrefix)} `"
        ></span>
        <span v-html="handleNewLine(getMessageToPost(post).slice(0, 80))"></span>{{getMessageToPost(post).length > 80 ? '...' : ''}}
        <span class="hashtag-suffix" v-if="activePrefixSuffix && bot && bot.hashtag && post.title != ''"
          v-html="` ${addHashtagsLinks(bot.hashtag)}`"
        ></span>
      </div>
      <div v-if="live && !doScreenshot && post.title != ''" class="live-title">
        <span class="btn-edit">
          <Tooltip
            :text="$t('dash.post.overlay.edit.message')"
            position="top"
          >
            <vs-button
              class="button-reel-edit"
              v-show="!activeEdit.title"
              vs-type="filled"
              @click.prevent="showEditPost('title')"
              icon="edit"
            ></vs-button>
            &nbsp;&nbsp;
          </Tooltip>
        </span>
      </div>
    </div>

    <div v-if="page.network === 'instagram' && shareAfterPost && page.story_config && page.story_config.created">
        <div class="vertical-line"><span>Storification</span></div>
        <story :class="!live && 'storification-preview-size'"
          :storification="{
            video: post.video || (multipleMedias && multipleMedias[0] && multipleMedias[0].type.includes('video') && multipleMedias[0].url),
            image: post.enclosure,
            username: page.name,
            isCarousel: (multipleImages && multipleImages.length > 1),
            widgetsReel: {
              texts: $store.getters.storificationTextsReel,
              gifs: $store.getters.storificationGifsReel,
              music: $store.getters.storificationMusicReel
            }
          }"
          :backgroundColor="$store.getters.storificationBackgroundColor"
          :link="{
            url: post.url,
            initialDatas: $store.getters.storificationLink,
            isActive: $store.getters.storificationLinkIsActive,
            text: $store.getters.storificationLinkText,
          }"
          :texts="$store.getters.storificationTexts"
          :gifs="$store.getters.storificationGifs"
          :music="$store.getters.storificationMusic"
          :layers="$store.getters.storificationLayers"
          :location="$store.getters.storificationLocation"
          :product="$store.getters.storificationProduct"
          :poll="$store.getters.storificationPoll"
          :slider="$store.getters.storificationSlider"
          :mentions="$store.getters.storificationMentions"
          :hashtags="$store.getters.storificationHashtags"
          :question="$store.getters.storificationQuestion"
          :template="{
            config: $store.getters.storificationTemplate,
            custom: currentBot ? currentBot.storyTemplate : null
          }"
          :preview="live ? null : {
            'Link': $store.getters.storificationLink,
            'Text': $store.getters.storificationTexts,
            'Layer': $store.getters.storificationLayers,
            'Gif': $store.getters.storificationGifs,
            'Poll': $store.getters.storificationPoll,
            'Slider':$store.getters.storificationSlider,
            'Mention': $store.getters.storificationMentions,
            'Hashtag': $store.getters.storificationHashtags,
            'Location': $store.getters.storificationLocation,
            'Product': $store.getters.storificationProduct,
            'Question': $store.getters.storificationQuestion,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
      </story>
    </div>
    <div v-if="page.network === 'instagram' && storyShareToFacebook && page.story_config && page.story_config.created">
        <div class="vertical-line"><span>Facebook</span></div>
         <story :class="!live && 'storification-preview-size'"
          :storification="{
            video: post.video || (multipleMedias && multipleMedias[0] && multipleMedias[0].type.includes('video') && multipleMedias[0].url),
            image: post.enclosure,
            username: page.name,
            isCarousel: (multipleImages && multipleImages.length > 1),
            widgetsReel: {
              texts: $store.getters.storificationTextsReel,
              gifs: $store.getters.storificationGifsReel,
              music: $store.getters.storificationMusicReel
            }
          }"
          :backgroundColor="$store.getters.storificationBackgroundColor"
          :link="{
            url: post.url,
            initialDatas: $store.getters.storificationLink,
            isActive: $store.getters.storificationLinkIsActive,
            text: $store.getters.storificationLinkText,
          }"
          :texts="$store.getters.storificationTexts"
          :layers="$store.getters.storificationLayers"
          :location="$store.getters.storificationLocation"
          :gifs="$store.getters.storificationGifs"
          :music="$store.getters.storificationMusic"
          :product="$store.getters.storificationProduct"
          :poll="$store.getters.storificationPoll"
          :slider="$store.getters.storificationSlider"
          :mentions="$store.getters.storificationMentions"
          :hashtags="$store.getters.storificationHashtags"
          :question="$store.getters.storificationQuestion"
          :template="{
            config: $store.getters.storificationTemplate,
            custom: currentBot ? currentBot.storyTemplate : null
          }"
          :preview="{
            'Link': $store.getters.storificationLink,
            'Text': $store.getters.storificationTexts,
            'Layer': $store.getters.storificationLayers,
            'Gif': $store.getters.storificationGifs,
            'Poll': $store.getters.storificationPoll,
            'Slider':$store.getters.storificationSlider,
            'Mention': $store.getters.storificationMentions,
            'Hashtag': $store.getters.storificationHashtags,
            'Location': $store.getters.storificationLocation,
            'Product': $store.getters.storificationProduct,
            'Question': $store.getters.storificationQuestion,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
      </story>
    </div>
    
  </div>
  
  <div v-else class="post preview" :class="page.network">
    <div class="customized" v-if="live && !doScreenshot && ((editPostValue && editPostValue.find(p => p.page == page.id)) || checkEditImage())">
      <div>
        <Tooltip
          :text="$t('dash.posts.customized.detail')"
          position="top"
        >
          {{ $t('dash.posts.customized') }}
          <vs-button
            vs-type="filled"
            @click="removeCustomized"
            icon="close"
          ></vs-button>
          &nbsp;
        </Tooltip>
      </div>
    </div>
  
    <div class="retweet" v-if="retweet">
      <svg viewBox="0 0 24 24" aria-hidden="true" class="r-14j79pv r-4qtqp9 r-yyyyoo r-10ptun7 r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1janqcz"><g><path d="M23.615 15.477c-.47-.47-1.23-.47-1.697 0l-1.326 1.326V7.4c0-2.178-1.772-3.95-3.95-3.95h-5.2c-.663 0-1.2.538-1.2 1.2s.537 1.2 1.2 1.2h5.2c.854 0 1.55.695 1.55 1.55v9.403l-1.326-1.326c-.47-.47-1.23-.47-1.697 0s-.47 1.23 0 1.697l3.374 3.375c.234.233.542.35.85.35s.613-.116.848-.35l3.375-3.376c.467-.47.467-1.23-.002-1.697zM12.562 18.5h-5.2c-.854 0-1.55-.695-1.55-1.55V7.547l1.326 1.326c.234.235.542.352.848.352s.614-.117.85-.352c.468-.47.468-1.23 0-1.697L5.46 3.8c-.47-.468-1.23-.468-1.697 0L.388 7.177c-.47.47-.47 1.23 0 1.697s1.23.47 1.697 0L3.41 7.547v9.403c0 2.178 1.773 3.95 3.95 3.95h5.2c.664 0 1.2-.538 1.2-1.2s-.535-1.2-1.198-1.2z"></path></g></svg>
      <p class="page-name">{{ retweet.name }} {{ $t('dash.posts.retweeted') }}</p>
    </div>

    <div class="align-items-horiz">
      <div class="page" :class="{ live }">
        <a :href="getPageUrl || null" target="blank" :class="!getPageUrl && 'black-text'">
          <page-image-avatar :page="page"/>
          <p class="page-name" v-if="page.network === 'instagram' && ((userTags && userTags.collab && userTags.collab.length) || (post.userTags && post.userTags.collab && post.userTags.collab.length))">
            {{userTags ? `${page.name} et ${userTags.list.filter(e=>userTags.collab.includes(e.id)).map(e => e.username).join(" et ")}` : `${page.name} et ${post.userTags.list.filter(e=> post.userTags.collab.includes(e.id)).map(e => e.username).join(" et ")}`}}        
          </p>
          <p class="page-name" v-else-if="page.network === 'instagram' && post.page && post.page[0] && post.page[0].userTags && JSON.parse(post.page[0].userTags).collab && JSON.parse(post.page[0].userTags).collab.length">
            {{`${page.name} et ${JSON.parse(post.page[0].userTags).list.filter(e=>JSON.parse(post.page[0].userTags).collab.includes(e.id)).map(e => e.username).join(" et ")}`}}        
          </p>
          <p v-else class="page-name">{{`${page.network === 'twitter' ? '@':''}${page.name}`}}</p>
        </a>
        <p v-if="page.network === 'instagram' && (location || post.location)" class="location-preview">
          {{location ? (location.instagram ? location.instagram.name : location.name) : (post.location.instagram ? post.location.instagram.name : post.location.name)}}        
        </p>
        <p v-if="page.network === 'instagram' && typePost === 'image' && ($store.getters.storificationMusic && ($store.getters.storificationMusic.track || $store.getters.storificationMusic.original_sound))" class="location-preview">
          {{$store.getters.storificationMusic.track.display_artist}} . {{$store.getters.storificationMusic.track.title}}      
        </p>
        <p v-else-if="page.network === 'facebook' && (location || post.location)" class="location-preview">
          <span>{{$t('dash.post.preview.location.is_to')}}</span> {{location ? (location.facebook ? location.facebook.name : location.name) : (post.location.facebook ? post.location.facebook.name : post.location.name)}}        
        </p>
        <p v-else-if="['instagram', 'facebook'].includes(page.network) && post.page && post.page[0] && post.page[0].location" class="location-preview">
          <span v-if="page.network == 'facebook'">{{$t('dash.post.preview.location.is_to')}}</span> {{locationName}}        
        </p>
        <p class="date" v-if="moderation && !['telegram', 'instagram', 'whatsapp', 'bluesky'].includes(page.network)">
          <Tooltip
            :text="dateFormat(post.date)"
            position="top"
          >
            <span>{{ dateFromNow(post.date) }}</span>
            &nbsp;
          </Tooltip>
        </p>
        <p class="date" v-else-if="!['telegram', 'instagram', 'whatsapp', 'bluesky'].includes(page.network)" @click.prevent="live && !activeEdit.scheduling && isUserPremiumActive ? showEditPost('scheduling') : null">
          {{ postDate }}
          <!-- <span v-if="page.network === 'facebook' && (location || post.location)" class="location-preview">
            . {{location ? (location.facebook ? location.facebook.name : location.name) : (post.location.facebook ? post.location.facebook.name : post.location.name)}}
          </span>
          <span v-else-if="page.network === 'facebook' && post.page && post.page[0] && post.page[0].location" class="location-preview">
            . {{locationName}}        
          </span> -->
          <span class="btn-edit" v-if="live && !doScreenshot">
            <Tooltip
              :text="$t('dash.post.overlay.edit.date')"
              position="top"
            >
              <vs-button
                v-show="live && !activeEdit.scheduling && isUserPremiumActive"
                vs-type="filled"
                @click.prevent="showEditPost('scheduling')"
                icon="edit"
              ></vs-button>
              &nbsp;&nbsp;
            </Tooltip>
          </span>
        </p>
        <div v-if="live && activeEdit.scheduling && !['telegram', 'instagram', 'whatsapp', 'bluesky'].includes(page.network)" class="live-scheduling schedule">
          <div class="schedule-wrapper">
            <div class="edit-scheduling">
              <component-datepicker
                class="posts-datepicker"
                v-on:picked="picked"
                :date="new Date(editValue.scheduling.date)"
                :now="true"
              ></component-datepicker>
              <div class="posts-timepicker">
                <img src="../../assets/img/icon_time_black.svg" alt="time">
                <vue-timepicker v-model="editValue.scheduling.time" :hour-range="rangeHour" :minute-range="rangeMinute" @change="changeRangeSchedulingTime" auto-scroll :minute-interval="minuteInterval"></vue-timepicker>
              </div>
              <vs-button
                vs-type="filled"
                @click.prevent="activeEdit.scheduling = false"
                icon="close"
              ></vs-button>
              <vs-button
                vs-type="filled"
                @click.prevent="editPost('scheduling')"
                icon="check"
              ></vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="message-truncated" v-if="textTruncated">
      {{ $t('dash.post.preview.message.truncated')}}
    </div>

    <div class="title" :class="[{'lorem' : post.title == '' && !moderation && !['image', 'video'].includes(typePost) , live}]" v-if="!['instagram', 'pinterest', 'google', 'youtube', 'whatsapp'].includes(page.network)">
      <div v-if="!activeEdit.title" @click.prevent="live && !activeEdit.title ? showEditPost('title') : null">
        <span class="hashtag-prefix" v-if="activePrefixSuffix && bot && bot.hashtagPrefix && post.title != ''"
          v-html="`${addHashtagsLinks(bot.hashtagPrefix)} `"
        ></span>
        <span 
          v-if="!disableCTA && post.page && post.page[0] && post.page[0].is_reshare" 
          v-html="handleNewLine(post.page[0].reshare_message)"
          class="title-preview"
        ></span>
        <span 
          v-else
          v-html="handleNewLine(getMessageToPost(post))"
          class="title-preview"
        ></span>
        <span class="hashtag-suffix" v-if="activePrefixSuffix && bot && bot.hashtag && post.title != ''"
          v-html="` ${addHashtagsLinks(bot.hashtag)}`"
        ></span>
      </div>
      <div v-if="live && !doScreenshot && post.title != ''" class="live-title">
        <span class="btn-edit">
          <Tooltip
            :text="$t('dash.post.overlay.edit.message')"
            position="top"
          >
            <vs-button
              v-show="!activeEdit.title"
              vs-type="filled"
              @click.prevent="showEditPost('title')"
              icon="edit"
            ></vs-button>
            &nbsp;&nbsp;
          </Tooltip>
        </span>
        <div class="edit-title" v-if="activeEdit.title">
          <vs-button
            vs-type="filled"
            @click.prevent="activeEdit.title = false"
            icon="close"
            class="close"
          ></vs-button>
          <vs-button
            vs-type="filled"
            @click.prevent="editPost('title')"
            icon="check"
            class="save"
          ></vs-button>
          
          <div class="textarea-emoji-picker" v-click-outside="hideEmojiPicker">
            <div class="styles-text-buttons" v-if="page.network !== 'bluesky'">
              <span @click="styleSelection('bold')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('bold') }">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#888888" d="M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z"/>
                </svg>
              </span>
              <span @click="styleSelection('italic')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('italic') }">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#888888" d="M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z "/>
                </svg>
              </span>
              <span @click="styleSelection('underline')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('underline') }">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#888888" d="M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z"/>
                  <path fill="#888888" d="M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z"/>
                </svg>
              </span>
            </div>
            <picker
              v-if="page.network !== 'bluesky'"
              :data="emojiIndex"
              v-show="showEmojiPicker"
              title="Pick your emoji..."
              emoji="point_up"
              @select="addEmoji"
            />
            <span
              v-if="page.network !== 'bluesky'"
              class="emoji-trigger"
              :class="{ 'triggered': showEmojiPicker }"
              @click="toggleEmojiPicker"
            >
              <svg
                style="width:20px;height:20px"
                viewBox="0 0 24 24"
              >
                <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
              </svg>
            </span>
            <span class="add-mention" @click="toggleShowMentions('Mention')">@</span>
            <span class="add-mention add-hashtag" @click="toggleShowMentions('Hashtag')" :class="{ 'disabled': !activeSearchHashtags}">#</span>
            <span class="add-mention ai-generate" @click="getAccrochesByAI()"><span class="material-icons">lightbulb_outline</span></span>
            <vs-textarea 
              :class="{'input': true}"
              vs-size="large"
              color="#B20564"
              name="title"
              :placeholder="$t('dash.posts.overlay.description_placeholder')"
              v-model="editValue.title"
              :ref="`inputTitle-${page.network_id}`"
              :id="`inputTitle-${page.network_id}`"
              @click="[checkAddMention()]"
              @keyup="[checkTruncate(), checkAddMention(), textAreaAdjust(`inputTitle-${page.network_id}`)]"
            /> 
            <div class="vs-textarea--count" v-if="limitText()">
              {{ sizeCurrentMessage() }} / {{ limitText() }}
            </div>  
          </div>
        </div>
      </div>
      <span v-if="(((image || post.video) && ['image', 'video'].includes(typePost)) 
                    || (post.page && post.page[0] 
                      && (post.page[0].enclosure || post.page[0].video)) 
                    || ((!post.status || post.status == 'preview') && bot && bot.mode === 'image' && !['standard', 'story'].includes(typePost))
                    || (['twitter', 'telegram'].includes(page.network) && meta && meta.og && !(meta.og.image || (meta.og.images && meta.og.images[0])))
                    || (['image'].includes(typePost) && meta && meta.og && (meta.og.image || (meta.og.images && meta.og.images[0])))
                  ) && post.url && page.network != 'instagram'"
      >
        <div class="link" v-if="live && !doScreenshot" :class="{visibility_off: isRemoveUrlInMessageToPost()}">
          <span>{{ getUrlWithUtm.substr(0, 42) }}...</span>
          
          <Tooltip class="visibility-link"
            :text="$t(`dash.posts.form.${isRemoveUrlInMessageToPost() ? 'show-url' : 'hide-url'}`)"
            position="left"
          >
            <i class="material-icons" @click="removeUrlInMessage()">{{ isRemoveUrlInMessageToPost() ? 'visibility' : 'visibility_off' }}</i>
            &nbsp;
        </Tooltip>
        </div>
        <span v-else-if="isRemoveUrlInMessageToPost()"></span>
        <a v-else :href="getUrlWithUtm" target="blank">
          <span>{{ getUrlWithUtm.substr(0, 42) }}...</span>
        </a>
      </span>
    </div>

    <div class="description" v-if="page.network =='wonderpush' && post.page && post.page[0] && post.page[0].description">
      <span v-html="handleNewLine(post.page[0].description, false, false, true)"></span>
    </div>
    <div class="description" v-else-if="['wonderpush'].includes(page.network) && post.description">
      <span v-html="handleNewLine(getMessageToPostDescription(post), false, false, true)"></span>
    </div>

    <p class="description" v-if="['telegram'].includes(page.network) && meta && meta.og">{{meta.og.description}}</p>
    
    <div class="card" v-if="reshare">
      <preview-post :page="resharePage" :post="reshare" :disableCTA="true"></preview-post>     
    </div>
    <Tooltip class="edit-image-mod"
        :text="$t('dash.posts.form.media')"
        position="left" v-if="['instagram', 'google'].includes(page.network) && typePost === 'standard' && meta && meta.og && meta.og.image"
        v-show="live && !doScreenshot"
    >
        <vs-button
          vs-type="filled"
          @click.prevent="showEditPost('image')"
          icon="edit"
        ></vs-button>
        &nbsp;
        <input ref="modifyImage" type="file" hidden/>
    </Tooltip>
    <div class="poll-container" v-if="(typePost === 'poll' && poll && poll.question != '') || (this.post && this.post.page && this.post.page[0] && this.post.page[0].poll && this.post.page[0].poll.question)">
      <span v-if="pollValue.question.length > 0" class="poll-question">{{pollValue.question}}</span>
      <div class="poll-options">
        <span v-for="opt in pollValue.options.filter(e=>e!='')" :key="opt">{{opt}}</span>
      </div>
      <span class="poll-duration">0 vote  • Il reste {{pollDuration}}</span>
    </div>
    <div class="pdf-viewer" v-else-if="page.network === 'linkedin' && (typePost === 'document' || (post.page && post.page[0] && post.page[0].document_title && post.page[0].document_title !== '') || (post.page && post.page[0] && post.page[0].enclosure && post.page[0].enclosure.endsWith('.pdf'))) && (image || (post.page && post.page[0] && post.page[0].enclosure))">
      <pdf v-if="pdfReset" @numpages="(n) => pdfPageNumber = n" :src="image || post.page[0].enclosure" :page="pdfPage"></pdf>
      <span class="pdf-title"><b>{{pdfTitle || (post.page && post.page[0] && post.page[0].document_title)}}</b> . {{pdfPageNumber}} pages</span>
      <span class="pdf-foot">{{pdfPage}} / {{pdfPageNumber}}</span>
      <svg @click="pdfPage--" v-if="pdfPage > 1" class="previous-page" viewBox="0 0 24 24" width="24px" height="24px" x="0" y="0" preserveAspectRatio="xMinYMin meet" focusable="false"><path d="M10,12l6,8.94L14.45,22,8.26,12.85a1.5,1.5,0,0,1,0-1.69L14.45,2,16,3.06Z" class="large-icon" style="fill: currentcolor; --darkreader-inline-fill: currentcolor;" data-darkreader-inline-fill=""></path></svg>
      <svg @click="pdfPage++" v-if="pdfPage < pdfPageNumber" class="next-page" viewBox="0 0 24 24" width="24px" height="24px" x="0" y="0" preserveAspectRatio="xMinYMin meet" focusable="false"><path d="M14,12L8,3.06,9.55,2l6.19,9.15a1.5,1.5,0,0,1,0,1.69L9.55,22,8,20.94Z" class="large-icon" style="fill: currentcolor; --darkreader-inline-fill: currentcolor;" data-darkreader-inline-fill=""></path></svg>
    </div>
    <div class="card" v-else-if="!disableCTA && post.page && post.page[0] && post.page[0].is_reshare">
      <preview-post :page="page" :post="post" :disableCTA="true"></preview-post>      
    </div> 

    <div class="post-image carrousel" v-else-if="carouselData && carouselData.length > 1 && ['instagram', 'threads'].includes(page.network)">
      <carousel 
        :perPage="page.network == 'threads' ? 2 : 1" 
        :scrollPerPage="page.network == 'threads' ? false : true" 
        :paginationEnabled="page.network == 'threads' ? false : true" 
        :adjustableHeight="true" 
        :centerMode="true"
      >
        <slide v-for="media in carouselData.filter(e => e.file)" :key="media.id">
          <div>
            <Tooltip class="compress-image-warning insta"
              :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && !compressedImages.includes(media.id)"
              v-show="live" style="position: relative !important;"
            >
              <img src="../../assets/img/compress.svg" alt="compress">
              &nbsp;
          </Tooltip>
          <img :style="`aspect-ratio: ${page.network === 'instagram' ? media.ratio === 0 ? firstImageAspectRatio : media.ratio : 'auto'};`" class="carrousel-image" :src="media.url"/>
          </div>
        </slide>
      </carousel>
    </div>
    <div class="post-image carrousel" v-else-if="carouselData && carouselData.length > 1 && ['twitter', 'bluesky'].includes(page.network)">
        <div class="carrousel-twitter" :style="`flex-direction: ${carouselPreview.length === 3 ? 'column-reverse' : 'row'}; flex-wrap: ${carouselPreview.length === 3 ? 'wrap-reverse' : 'wrap'};`">
          <span v-for="media in carouselPreview" :key="media.id" @dragstart="dragOrderCarouselStart" @dragover="e => dragOrderCarousel(e, 'twitter')" @drop="dragOrderCarouselStop" @dragleave="dragCarouselLeave"
            class="carrousel-image-split-container" :style="`width: ${carouselPreview.length > 2 ? '50%' : '100%'}; height: ${carouselPreview.length > 3 ? '50%' : '100%'};`">
            <Tooltip class="compress-image-warning"
              :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && !compressedImages.includes(media.id)"
              v-show="live"
            >
              <img src="../../assets/img/compress.svg" alt="compress">
              &nbsp;
          </Tooltip>
            <img class="carrousel-image-split" :src="media.url" :id="media.id"/>
          </span>
        </div>
    </div>
    <div class="post-image carrousel" v-else-if="carouselData && carouselData.length > 1 && page.network === 'linkedin'">
        <div class="carrousel-linkedin" 
          :style="`flex-direction: ${carouselPreview.length > 2 ? 'row-reverse' : 'row'}; 
          flex-wrap: ${carouselPreview.length > 2 ? 'wrap-reverse' : 'wrap'};`">
            <span @dragstart="dragOrderCarouselStart" @dragover="e => dragOrderCarousel(e, 'linkedin')" @drop="dragOrderCarouselStop" @dragleave="dragCarouselLeave"
              v-for="(media, idx) in carouselPreview" :key="media.id" class="carrousel-image-split-container"
              :style="`height: ${carouselPreview.length > 4 && idx > 2 ? '60%' : carouselPreview.length > 2 ? idx === carouselPreview.length-1  ? '60%' : '40%' : 'auto'}; 
              flex-basis: ${carouselPreview.length > 4 && idx > 2 ? '50%' : carouselPreview.length > 3 ? idx > 2 ? '100%' : '33%' : '50%'};`">
              <Tooltip class="compress-image-warning"
              :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && !compressedImages.includes(media.id)"
              v-show="live"
            >
              <img src="../../assets/img/compress.svg" alt="compress">
              &nbsp;
          </Tooltip>
              <img class="carrousel-image-split" :src="media.url" :id="media.id"/>
            </span>
          <div v-if="carouselData.filter(e=>e.file).length > 5" class="more-image">+{{carouselData.filter(e=>e.file).length - 5}}</div>
        </div>
    </div>
    <div class="post-image carrousel" v-else-if="carouselData && carouselData.length > 1 && page.network === 'facebook'">
        <div class="carrousel-facebook" :style="`aspect-ratio: ${carouselPreview.length > 3 ? 1 : carouselPreview.length === 3 ? 0.9 : carouselPreview.length};
          flex-direction: ${carouselPreview.length === 3 ? 'row-reverse' : 'row'};
          flex-wrap: ${carouselPreview.length === 3 ? 'wrap-reverse' : 'wrap'};`">
          <span v-for="(media, idx) in carouselPreview" :key="media.id" class="carrousel-image-split-container" @dragstart="dragOrderCarouselStart" @dragover="e => dragOrderCarousel(e, 'facebook')" @drop="dragOrderCarouselStop" @dragleave="dragCarouselLeave"
            :style="`width: ${carouselPreview.length === 3 && idx === 2 ? '100%' : 'auto'}; height: ${carouselPreview.length > 2 ? '50%' : 'auto'}`">
            <Tooltip class="compress-image-warning"
              :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && !compressedImages.includes(media.id)"
              v-show="live"
            >
              <img src="../../assets/img/compress.svg" alt="compress">
              &nbsp;
          </Tooltip>
            <img class="carrousel-image-split" :src="media.url" :id="media.id"/>
          </span>
          <div v-if="carouselData.filter(e=>e.file).length > 4" class="more-image">+{{carouselData.filter(e=>e.file).length - 3}}</div>
        </div>
    </div>
    <div class="post-image video carrousel" v-else-if="((multipleMedias && multipleMedias.length > 1) || (post.page && post.page.length && post.page[0].multipleMedias && post.page[0].multipleMedias.length > 1)) && ['instagram', 'threads'].includes(page.network)">
      <carousel 
        :perPage="page.network == 'threads' ? 2 : 1" 
        :scrollPerPage="page.network == 'threads' ? false : true" 
        :paginationEnabled="page.network == 'threads' ? false : true" 
        :adjustableHeight="true" 
        :centerMode="true"
      >
        <slide v-for="media in (multipleMedias || post.page[0].multipleMedias).filter(e => e.url)" :key="media.id">
          <div>
            <!-- <Tooltip class="compress-image-warning insta"
              :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && !compressedImages.includes(media.id)"
              v-show="live" style="position: relative !important;"
            >
              <img src="../../assets/img/compress.svg" alt="compress">
              &nbsp;
          </Tooltip> -->
          <img v-if="media.type.includes('image')" :style="`aspect-ratio: ${page.network === 'instagram' ? media.ratio : 'auto'};`" class="carrousel-image" :src="media.url"/>
          <video v-else-if="media.type.includes('video')" :id="live ? `video-${page.id}` : ''" class="ratio" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="media.url" controls/>
          </div>
        </slide>
      </carousel>
    </div>
    <story v-else-if="(page.network === 'instagram' || page.network === 'facebook') && typePost === 'story'" :class="!live && 'storification-preview-size'"
          :story="!storificationObject ? {
            image: imageStory,
            video: videoStory
          } : undefined"
          :storification="storificationObject ? {
            image: (carouselData && carouselData[0] && carouselData[0].url) || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: storificationObject.username,
            isCarousel: storificationObject.isCarousel || (carouselData && carouselData.length > 1)
          } : undefined"
          :backgroundColor="$store.getters.storificationBackgroundColor"
          :link="{
            url: post.url,
            initialDatas: $store.getters.storificationLink,
            isActive: $store.getters.storificationLinkIsActive,
            text: $store.getters.storificationLinkText,
          }"
          :texts="$store.getters.storificationTexts"
          :layers="$store.getters.storificationLayers"
          :gifs="$store.getters.storificationGifs"
          :music="$store.getters.storificationMusic"
          :location="$store.getters.storificationLocation"
          :product="$store.getters.storificationProduct"
          :poll="$store.getters.storificationPoll"
          :slider="$store.getters.storificationSlider"
          :mentions="$store.getters.storificationMentions"
          :hashtags="$store.getters.storificationHashtags"
          :question="$store.getters.storificationQuestion"
          :template="{
            config: $store.getters.storificationTemplate,
            custom: currentBot ? currentBot.storyTemplate : null
          }"
          :preview="(live && index === 0) ? null : {
            'Link': $store.getters.storificationLink,
            'Text': $store.getters.storificationTexts,
            'Layer': $store.getters.storificationLayers,
            'Gif': $store.getters.storificationGifs,
            'Poll': $store.getters.storificationPoll,
            'Slider':$store.getters.storificationSlider,
            'Mention': $store.getters.storificationMentions,
            'Hashtag': $store.getters.storificationHashtags,
            'Location': $store.getters.storificationLocation,
            'Product': $store.getters.storificationProduct,
            'Question': $store.getters.storificationQuestion,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
    </story>

    <div class="post-image video" v-else-if="post.video && typeof post.video === 'string' && post.video.includes('http')">
      <video :id="live ? `video-${page.id}` : ''" :class="`ratio${videoReel ? '-reel':''}`" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="post.video" :poster="image || post.page[0].enclosure" controls v-if="['linkedin', 'facebook', 'instagram'].includes(page.network) && (image || (post.page && post.page[0] && post.page[0].enclosure))"/>
      <video :id="live ? `video-${page.id}` : ''" :class="`ratio${videoReel ? '-reel':''}`" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="post.video" controls v-else/>
    </div>
    <div class="post-image video" v-else-if="post.videos && post.videos[page.network] && post.videos[page.network].includes('http')">
      <video :id="live ? `video-${page.id}` : ''" :class="`ratio${videoReel ? '-reel':''}`" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="post.videos[page.network]" :poster="image || post.page[0].enclosure" controls v-if="['linkedin', 'facebook', 'instagram'].includes(page.network) && (image || (post.page && post.page[0] && post.page[0].enclosure))"/>
      <video :id="live ? `video-${page.id}` : ''" :class="`ratio${videoReel ? '-reel':''}`" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="post.videos[page.network]" controls v-else/>
    </div>
    <div class="post-image video" v-else-if="post.page && post.page[0] && post.page[0].video">
      <video :id="live ? `video-${page.id}` : ''" :class="`ratio${videoReel ? '-reel':''}`" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="post.page[0].video" :poster="image || post.page[0].enclosure" controls v-if="['linkedin', 'facebook', 'instagram'].includes(page.network) && (image || (post.page && post.page[0] && post.page[0].enclosure))"/>
      <video :id="live ? `video-${page.id}` : ''" :class="`ratio${videoReel ? '-reel':''}`" crossorigin="anonymous" @loadedmetadata="videoRatio" :src="post.page[0].video" controls v-else/>
    </div>

     <div class="post-image" v-else-if="(editValue.imageBase64 || (editPostValue && editPostValue.filter(e => e.page === page.id).length > 0 && editPostValue.filter(e => e.page === page.id)[0].imageBase64)) && (page.network === 'instagram' || page.network === 'google')">
      <!-- <Tooltip class="compress-image-warning insta"
          :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && (editValue.imageBase64 || (editPostValue && editPostValue.filter(e => e.page === page.id)[0].imageBase64))"
          v-show="live"
        >
          <img src="../../assets/img/compress.svg" alt="compress">
          &nbsp;
      </Tooltip> -->
      <img ref="imageRef" :src="editValue.imageBase64 || (editPostValue && editPostValue.filter(e => e.page === page.id)[0].imageBase64)" @load="limitImage" @error="replaceByDefault" :class="`post-image-img`">
    </div>

    <div class="post-image" v-else-if="image && (typePost === 'image' || page.network === 'instagram' || page.network === 'google')">
      <Tooltip class="compress-image-warning insta"
          :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && compressedImages.length === 0 && image"
          v-show="live"
        >
          <img src="../../assets/img/compress.svg" alt="compress">
          &nbsp;
      </Tooltip>
      <img ref="imageRef" :src="image" @load="limitImage" @error="replaceByDefault" :class="`post-image-img`">
        
    </div>

    <div class="post-image" v-else-if="page.network === 'linkedin' && post.enclosure && bot && bot.mode === 'image' && ((!post.status && !typePost) || post.status == 'preview')">
      <Tooltip class="compress-image-warning insta"
          :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && compressedImages.length === 0 && post.enclosure"
          v-show="live"
        >
          <img src="../../assets/img/compress.svg" alt="compress">
          &nbsp;
      </Tooltip>
      <img ref="imageRef" @load="limitImage" :src="post.enclosure">
    </div>
    <div class="post-image" v-else-if="post.page && post.page[0] && post.page[0].enclosure && !post.meta">
      <Tooltip class="compress-image-warning insta"
          :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && compressedImages.length === 0 && post.page[0].enclosure"
          v-show="live"
        >
          <img src="../../assets/img/compress.svg" alt="compress">
          &nbsp;
      </Tooltip>
      <img ref="imageRef" @load="limitImage" :src="post.page[0].enclosure" @error="replaceByDefault">
    </div>
    
    <div class="post-image" v-else-if="post.enclosure && typePost === 'image'">
      <Tooltip class="compress-image-warning insta"
          :text="$t('dash.post.compressed.image.warning.in_progress')"
              position="left" v-if="compressedImages && compressedImages.length === 0 && post.enclosure"
          v-show="live"
        >
          <img src="../../assets/img/compress.svg" alt="compress">
          &nbsp;
      </Tooltip>
      <img ref="imageRef" @load="limitImage" :src="post.enclosure" @error="replaceByDefault">
    </div>
    <div class="post-image" v-else-if="['pinterest', 'instagram', 'wonderpush'].includes(page.network) || typePost === 'image' || (((!post.status && !typePost) || post.status == 'preview') && bot && bot.mode === 'image')">
      <Tooltip class="compress-image-warning insta"
          ::text="$t('dash.post.compressed.image.warning')"
              position="left" v-if="needCompress.length"
          v-show="live"
        >
          <img src="../../assets/img/compress.svg" alt="compress">
          &nbsp;
      </Tooltip>
      <img ref="imageRef" @load="limitImage" v-if="meta && meta.og && (meta.og.image || (meta.og.images && meta.og.images.length))"  :class="`post-image-img`" :src="meta.og.image || meta.og.images[0].url" @error="replaceByDefault">
      <img ref="imageRef" @load="limitImage" v-else-if="['linkedin', 'facebook', 'instagram'].includes(page.network) && meta && meta.images && meta.images[0] && meta.images[0].url" :src="meta.images[0].url" @error="replaceByDefault">
    </div>

    <div class="link" v-else-if="['oneSignal', 'wonderpush', 'batch'].includes(page.network)">
      <br v-if="post.url"/>
      <a v-if="post.url" :href="post.url" target="_blank">{{ post.url }}</a>
    </div>

    <div class="link" v-else-if="['twitter', 'telegram'].includes(page.network) && meta && meta.og && !(meta.og.image || (meta.og.images && meta.og.images[0]))"></div>
    
    <div class="card" v-else-if="typePost !== 'video' && !showLoader && ((page.network === 'linkedin' && post.enclosure) || (meta && meta.og && (meta.og.image || (meta.og.images && meta.og.images[0]) || (meta.images && meta.images[0]))))">
      <div class="card-link-thumbnail" @click="goToLink(live ? null : getUrlWithUtm)">
        <p v-if="page.network === 'telegram' && meta && meta.og" class="card-sitename">{{meta.og.site_name}}</p>
        <div class="image-wrapper">
          <img v-if="['facebook', 'whatsapp'].includes(page.network) && post && post.page && post.page[0] && post.page[0].snippetInbox" class="card-img-top" :style="page.network === 'facebook' && 'aspect-ratio: 1.91; object-fit: cover;'" :src="post.page[0].snippetInbox.enclosure">
          <img v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && injectedSnippet" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" class="card-img-top" :style="page.network === 'facebook' && 'aspect-ratio: 1.91; object-fit: cover;'" :src="getUrlObjectSnippet(injectedSnippet)"> <!--@error="replaceByDefault">-->
          <img v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && post.page && post.page[0] && post.page[0].snippet" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" class="card-img-top" :style="page.network === 'facebook' && 'aspect-ratio: 1.91; object-fit: cover;'" :src="post.enclosure || post.page[0].snippet"> <!--@error="replaceByDefault">-->
          <img v-else-if="meta && meta.og && (meta.og.image || (meta.og.images && meta.og.images[0]))" @click.prevent="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live && !activeEdit.snippet ? showEditPost('snippet') : null" class="card-img-top" :src="meta.og.image || meta.og.images[0].url" :alt="meta.og.title"> <!--@error="replaceByDefault">-->
          <img v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && meta && meta.images && meta.images[0] && meta.images[0].url" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" :src="meta.images[0].url"> <!--@error="replaceByDefault">-->
          <img v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && post.enclosure" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" class="card-img-top" :style="page.network === 'facebook' && 'aspect-ratio: 1.91; object-fit: cover;'" :src="post.enclosure || post.page[0].snippet"> <!--@error="replaceByDefault">-->
        </div>
        <div class="card-block" v-if="!['google'].includes(page.network)">
          <h4 v-if="['facebook', 'whatsapp'].includes(page.network) && post && post.page && post.page[0] && post.page[0].snippetInbox" class="card-title">{{post.page[0].snippetInbox.title}}</h4>
          <h4 v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && (post && post.page && post.page[0] && post.page[0].snippet_title)" @click.prevent="live && !activeEdit.snippet_title ? showEditPost('snippet_title') : null" class="card-title">{{post.page[0].snippet_title}}</h4>
          <div v-else-if="activeEdit.snippet_title" class="edit-snippet-input" >
            <textarea ref="snippetTitle" class="card-title" :value="snippetTitle || (meta ? meta.meta.title : 'No data')"
            @input="e => {e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + (e.target.offsetHeight - e.target.clientHeight) + 'px';}"/>
            <vs-button
              vs-type="filled"
              @click.prevent="activeEdit.snippet_title = false; $forceUpdate();"
              icon="close"
              class="close"
            ></vs-button>
            <vs-button
              vs-type="filled"
              @click.prevent="validateSnippetTitle"
              icon="check"
            ></vs-button>
          </div>
          <!-- <h4 v-else class="card-title" @click.prevent="['linkedin', 'facebook'].includes(page.network) &&  live && !activeEdit.snippet_title ? showEditPost('snippet_title') : null">{{injectedSnippetTitle || snippetTitle || (meta ? removeHtml( meta.og.title || ['linkedin', 'facebook'].includes(page.network) ? meta.meta.title : null) : 'No data')}}</h4> -->
          <h4 v-else class="card-title" @click.prevent="['linkedin', 'facebook', 'whatsapp'].includes(page.network) &&  live && !activeEdit.snippet_title ? showEditPost('snippet_title') : null">{{injectedSnippetTitle || snippetTitle || (meta ? removeHtml( meta.og.title || ['linkedin', 'facebook'].includes(page.network) ? meta.meta.title : null) : getHostName(post.url).replace('www.', '').toUpperCase())}}</h4>
          <Tooltip v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live" class="edit-snippet-title"
            :text="$t('dash.post.overlay.edit.snippet.title')"
            position="left"
            v-show="live && !doScreenshot && !activeEdit.snippet_title"
          >
            <vs-button
              vs-type="filled"
              @click.prevent="showEditPost('snippet_title')"
              icon="edit"
            ></vs-button>
            &nbsp;
          </Tooltip>
          <p class="card-text">{{meta ? removeHtml(meta.og.description || ['linkedin', 'facebook', 'whatsapp'].includes(page.network) ? meta.og.description || meta.meta.description : null) : null}}</p>
          <p v-if="!['telegram'].includes(page.network)" class="card-sitename">{{meta && page.network !== 'bluesky' ? meta.og.site_name : getHostName(post.url)}}</p>
        </div>
      </div>

      <Tooltip class="edit-snippet"
            :text="$t('dash.post.overlay.edit.snippet')"
            position="left" v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live"
            v-show="live && !doScreenshot && !activeEdit.snippet"
      >
        <vs-button
          vs-type="filled"
          @click.prevent="showEditPost('snippet')"
          icon="edit"
        ></vs-button>
        &nbsp;
      </Tooltip>
      <div class="linkedin-snippet" v-if="activeEdit.snippet">
        <span @click="activeEdit.snippet_title = true; $forceUpdate();" v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live" class="linkedin-title-snippet">
          <img src="../../assets/img/linkedin_link_title.svg">
          Modifier le titre de l'article
        </span>
        <label v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live" for="linkedin-snippet" class="linkedin-image-snippet">
              <Tooltip text="Modifier l'image du lien" position="top" >
                <img src="../../assets/img/linkedin_snippet.svg" alt="">
                &nbsp;
              </Tooltip>
        </label>
        <span @click="activeEdit.snippet = false; $forceUpdate()" class="linkedin-close-snippet">x</span>
        <input id="linkedin-snippet" type="file" hidden @change="selectLinkedinSnippet" />
      </div>
    </div>
    <div class="card" v-else-if="typePost !== 'video' && post.meta && (post.meta.og || (post.meta.og.images && post.meta.og.images[0]))">
      <div class="card-link-thumbnail" @click="goToLink(live ? null : post.meta.og.url || post.meta.og.site)">
        <img class="card-img-top" :src="post.meta.og.image || post.meta.og.images[0].url" :alt="post.meta.og.title">
        <div class="card-block">
          <h4 class="card-title">{{removeHtml(post.meta.og.title)}}</h4>
          <p class="card-text">{{removeHtml(post.meta.og.description)}}</p>
          <p v-if="page.network !== 'telegram'" class="card-sitename">{{page.network === 'bluesky' ? getHostName(post.url) : post.meta.og.site_name}}</p>
        </div>
      </div>
    </div>
    <!-- SNIPPET ARTICLE LINKEDIN § §§ § § §  -->
    <div class="card" v-else-if="typePost === 'standard' && post.meta && post.content.shareMediaCategory == 'ARTICLE'">
      <div class="card-link-thumbnail" @click="goToLink(live ? null : post.meta.og.site)">
        <img v-if="post.meta && post.meta.og && post.meta.og.image" class="card-img-top" :src="post.meta.og.image" :alt="post.meta.og.title" @error="replaceByDefault">
        <img v-else-if="page.network === 'linkedin' && post.meta && post.meta.images && post.meta.images[0] && post.meta.images[0].url" :src="post.meta.images[0].url" @error="replaceByDefault">
        <div class="card-block">
          <h4 class="card-title">{{removeHtml(post.meta.og.title)}}</h4>
          <p class="card-text">{{removeHtml(post.meta.og.description)}}</p>
        </div>
      </div>
        
    </div>
    <div class="card" v-else-if="typePost === 'standard' && !['twitter', 'telegram'].includes(page.network) && meta && meta.meta && meta.meta.title">
      <div class="card-link-thumbnail" @click="goToLink(live ? null : getUrlWithUtm)">
        <div class="card-block" v-if="meta && meta.og && !['google'].includes(page.network)">
          <h4 class="card-title">{{removeHtml(meta.og.title || ['linkedin', 'facebook'].includes(page.network) ? meta.meta.title : null)}}</h4>
          <p class="card-text">{{removeHtml(meta.og.description || ['linkedin', 'facebook'].includes(page.network) ? meta.meta.description : null)}}</p>
          <p v-if="!['telegram'].includes(page.network)" class="card-sitename">{{meta.og.site_name || getHostName(post.url)}}</p>
        </div>
      </div>
    </div>
    <div class="card" v-else-if="typePost === 'standard' && post.url && !showLoader">
      <div class="card-link-thumbnail" @click="goToLink(live ? null : getUrlWithUtm)">
        <p v-if="page.network === 'telegram'" class="card-sitename">{{getHostName(post.url)}}</p>
        <img v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && injectedSnippet" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" class="card-img-top" :style="page.network === 'facebook' && 'aspect-ratio: 1.91; object-fit: cover;'" :src="getUrlObjectSnippet(injectedSnippet)"> <!--@error="replaceByDefault">-->
        <img v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && post.page && post.page[0] && post.page[0].snippet" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" class="card-img-top" :style="page.network === 'facebook' && 'aspect-ratio: 1.91; object-fit: cover;'" :src="post.enclosure || post.page[0].snippet"> <!--@error="replaceByDefault">-->
        <img v-else-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network)" @click.prevent="live && !activeEdit.snippet ? showEditPost('snippet') : null" src="../../assets/img/no-picture.png" class="error"> <!--@error="replaceByDefault">-->
        <div class="card-block" v-if="!['google'].includes(page.network)">
          <h4 v-if="['linkedin', 'whatsapp'].includes(page.network) && (post && post.page && post.page[0] && post.page[0].snippet_title)" @click.prevent="live && !activeEdit.snippet_title ? showEditPost('snippet_title') : null" class="card-title a">{{post.page[0].snippet_title}}</h4>
          <div v-else-if="activeEdit.snippet_title" class="edit-snippet-input" >
            <textarea ref="snippetTitle" class="card-title" :value="snippetTitle"
            @input="e => {e.target.style.height = 'auto'; e.target.style.height = e.target.scrollHeight + (e.target.offsetHeight - e.target.clientHeight) + 'px';}"/>
            <vs-button
              vs-type="filled"
              @click.prevent="activeEdit.snippet_title = false; $forceUpdate();"
              icon="close"
              class="close"
            ></vs-button>
            <vs-button
              vs-type="filled"
              @click.prevent="validateSnippetTitle"
              icon="check"
            ></vs-button>
          </div>
          <!-- <h4 v-else class="card-title b" @click.prevent="['linkedin', 'facebook'].includes(page.network) &&  live && !activeEdit.snippet_title ? showEditPost('snippet_title') : null">{{injectedSnippetTitle || snippetTitle || 'No data'}}</h4> -->
          <h4 v-else class="card-title b" @click.prevent="['linkedin', 'facebook', 'whatsapp'].includes(page.network) &&  live && !activeEdit.snippet_title ? showEditPost('snippet_title') : null">{{injectedSnippetTitle || snippetTitle || getHostName(post.url).replace('www.', '').toUpperCase()}}</h4>
          <Tooltip v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live" class="edit-snippet-title"
            :text="$t('dash.post.overlay.edit.snippet.title')"
            position="left"
            v-show="live && !doScreenshot && !activeEdit.snippet_title"
          >
            <vs-button
              vs-type="filled"
              @click.prevent="showEditPost('snippet_title')"
              icon="edit"
            ></vs-button>
            &nbsp;
          </Tooltip>
          <p class="card-text"></p>
          <p v-if="!['telegram'].includes(page.network)" class="card-sitename">{{getHostName(post.url)}}</p>
        </div>
      </div>
      <Tooltip class="edit-snippet"
            :text="$t('dash.post.overlay.edit.snippet')"
            position="left" v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live"
            v-show="live && !doScreenshot && !activeEdit.snippet"
      >
        <vs-button
          vs-type="filled"
          @click.prevent="showEditPost('snippet')"
          icon="edit"
        ></vs-button>
        &nbsp;
      </Tooltip>
      <div class="linkedin-snippet" v-if="activeEdit.snippet">
        <span @click="activeEdit.snippet_title = true; $forceUpdate();" v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live" class="linkedin-title-snippet">
          <img src="../../assets/img/linkedin_link_title.svg">
          Modifier le titre de l'article
        </span>
        <label v-if="['linkedin', 'facebook', 'whatsapp'].includes(page.network) && live" for="linkedin-snippet" class="linkedin-image-snippet">
              <Tooltip text="Modifier l'image du lien" position="top" >
                <img src="../../assets/img/linkedin_snippet.svg" alt="">
                &nbsp;
              </Tooltip>
        </label>
        <span @click="activeEdit.snippet = false; $forceUpdate()" class="linkedin-close-snippet">x</span>
        <input id="linkedin-snippet" type="file" hidden @change="selectLinkedinSnippet" />
      </div>
    </div>

 
    <component-loader :progress="90" :unlimitedProgress="true" v-if="showLoader"></component-loader>

    <Tooltip :style="{top : typePost === 'video' ? '-80px' : '-50px' }" position="top" :text="productTags ? productTags.length + ' ' + $t('dash.post.text.product') + (productTags.length > 1 ? 's' : '') : post.productTags.length + ' ' + $t('dash.post.text.product') + (productTags.length > 1 ? 's' : '')" v-if="page.network === 'instagram' && typePost !== 'story' && ((productTags && productTags.length) || (post.productTags && post.productTags.length)) && (image || post.video || post.enclosure || post.url)" class="tags">
      <i class="material-icons">local_mall</i>
      &nbsp;
    </Tooltip>
    <Tooltip :style="{top : typePost === 'video' ? '-80px' : '-50px' }" position="top" :text="userTags ? userTags.list.map(e=>e.username).join(', ') : post.userTags.list.map(e=>e.username).join(', ')" v-if="page.network === 'instagram' && (userTags || post.userTags) && (image || post.video || post.enclosure || post.url)" class="tags">
      <i class="material-icons">person</i>
      &nbsp;
    </Tooltip>
    <Tooltip :style="{top : typePost === 'video' ? '-80px' : '-50px' }" v-else-if="page.network === 'instagram' && post.page && post.page[0] && post.page[0].userTags" :text="JSON.parse(post.page[0].userTags).list.map(e=>e.username).join(', ')" class="tags">
      <i class="material-icons">person</i>
      &nbsp;
    </Tooltip>
  
    <div class="cta" v-if="!moderation && !disableCTA">
      <template v-if="page.network === 'facebook'">
        <div class="like"></div>
        <div class="comment"></div>
        <div class="share"></div>
      </template>
      <template v-else-if="page.network === 'twitter'">
        <div><svg viewBox="0 0 24 24" class="blue"><g><path d="M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z"></path></g></svg></div>
        <div><svg viewBox="0 0 24 24" class="green"><g><path d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z"></path></g></svg></div>
        <div><svg viewBox="0 0 24 24" class="red"><g><path d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z"></path></g></svg></div>
        <div><svg viewBox="0 0 24 24" class="blue"><g><path d="M17.53 7.47l-5-5c-.293-.293-.768-.293-1.06 0l-5 5c-.294.293-.294.768 0 1.06s.767.294 1.06 0l3.72-3.72V15c0 .414.336.75.75.75s.75-.336.75-.75V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22c.293-.293.293-.767 0-1.06z"></path><path d="M19.708 21.944H4.292C3.028 21.944 2 20.916 2 19.652V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 1.264-1.028 2.292-2.292 2.292z"></path></g></svg></div>
        <div><svg viewBox="0 0 24 24" class="blue"><g><path d="M12 22c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v18.5c0 .414-.336.75-.75.75zm5.14 0c-.415 0-.75-.336-.75-.75V7.89c0-.415.335-.75.75-.75s.75.335.75.75v13.36c0 .414-.337.75-.75.75zM6.86 22c-.413 0-.75-.336-.75-.75V10.973c0-.414.337-.75.75-.75s.75.336.75.75V21.25c0 .414-.335.75-.75.75z"></path></g></svg></div>  
      </template>
      <template v-else-if="page.network === 'linkedin'">
        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-supported-dps="24x24" fill="currentColor" width="24" height="24" focusable="false"><path d="M17.51 11l-2.15-3a14.81 14.81 0 01-2.25-5.29L12.74 1H10.5A2.5 2.5 0 008 3.5v.58a9 9 0 00.32 2.39L9 9H4.66A2.61 2.61 0 002 11.4a2.48 2.48 0 00.39 1.43 2.48 2.48 0 00.69 3.39 2.46 2.46 0 001.45 2.92 2.47 2.47 0 000 .36A2.5 2.5 0 007 22h4.52a8 8 0 001.94-.24l3-.76H21V11h-3.49zM19 19h-2.12l-3.41.82A6 6 0 0112 20H7a.9.9 0 01-.9-.89v-.14l.15-1-1-.4a.9.9 0 01-.55-.83.93.93 0 010-.22l.3-.95-.73-.57a.9.9 0 01-.39-.74.88.88 0 01.12-.44l.46-.72-.46-.72a.88.88 0 01-.14-.51 1 1 0 011-.87h6.64l-1.3-4.7a9 9 0 01-.33-2.37v-.55a.5.5 0 01.5-.5h.95a17.82 17.82 0 002.52 6.22L16.6 13H19v6z"></path></svg></div>
        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-supported-dps="24x24" fill="currentColor" width="24" height="24" focusable="false"><path d="M18 10H6V9h12v1zm4-5v17l-5-4H3a1 1 0 01-1-1V5a1 1 0 011-1h18a1 1 0 011 1zm-2 1H4v10h13.7l2.3 1.84V6zm-4 6H8v1h8v-1z"></path></svg></div>
        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-supported-dps="24x24" fill="currentColor" width="24" height="24" focusable="false"><path d="M24 12a1.18 1.18 0 00-.36-.84L14 2v6h-3A10 10 0 001 18v4h1.87A6.11 6.11 0 019 16h5v6l9.63-9.14A1.18 1.18 0 0024 12zm-8 5.54V14H9a8.15 8.15 0 00-6 2.84A8 8 0 0111 10h5V6.48L21.81 12z"></path></svg></div>
        <div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-supported-dps="24x24" fill="currentColor" width="24" height="24" focusable="false"><path d="M19.27 4.73l-4.91 12.9-2.18-5.81-5.81-2.18 12.9-4.91m2-2.73a1 1 0 00-.28 0L1 9.65l9.71 3.64L14.35 23 22 3.05A.78.78 0 0021.23 2z"></path></svg></div>
      </template>
      <template v-else-if="page.network === 'instagram'">
        <div><svg aria-label="J’aime" class="_8-yf5 " fill="#262626" height="24" viewBox="0 0 48 48" width="24"><path d="M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z"></path></svg></div>
        <div><svg aria-label="Commenter" class="_8-yf5 " fill="#262626" height="24" viewBox="0 0 48 48" width="24"><path clip-rule="evenodd" d="M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z" fill-rule="evenodd"></path></svg></div>  
        <div><svg aria-label="Partager la publication" class="_8-yf5 " fill="#262626" height="24" viewBox="0 0 48 48" width="24"><path d="M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z"></path></svg></div>
        <div><svg aria-label="Enregistrer" class="_8-yf5 " fill="#262626" height="24" viewBox="0 0 48 48" width="24"><path d="M43.5 48c-.4 0-.8-.2-1.1-.4L24 29 5.6 47.6c-.4.4-1.1.6-1.6.3-.6-.2-1-.8-1-1.4v-45C3 .7 3.7 0 4.5 0h39c.8 0 1.5.7 1.5 1.5v45c0 .6-.4 1.2-.9 1.4-.2.1-.4.1-.6.1zM24 26c.8 0 1.6.3 2.2.9l15.8 16V3H6v39.9l15.8-16c.6-.6 1.4-.9 2.2-.9z"></path></svg></div>
      </template>
    </div>

    <div class="title" :class="[{'lorem' : post.title == '' && !moderation, live }]" v-if="['instagram', 'pinterest', 'google', 'youtube', 'whatsapp'].includes(page.network) && typePost !== 'story'">
      <b v-if="page.network === 'instagram'">{{ page.name }}</b>
      <div v-if="!activeEdit.title" @click.prevent="live && !activeEdit.title ? showEditPost('title') : null">
        <span class="hashtag-prefix" v-if="activePrefixSuffix && bot && bot.hashtagPrefix && post.title != ''"
          v-html="`${addHashtagsLinks(bot.hashtagPrefix)} `"
        ></span>
        <span v-html="handleNewLine(getMessageToPost(post))"></span>
        <span class="hashtag-suffix" v-if="activePrefixSuffix && bot && bot.hashtag && post.title != ''"
          v-html="` ${addHashtagsLinks(bot.hashtag)}`"
        ></span>
      </div>
      <div v-if="live && !doScreenshot && post.title != ''" class="live-title">
        <span class="btn-edit">
          <Tooltip
            :text="$t('dash.post.overlay.edit.message')"
            position="top"
          >
            <vs-button
              v-show="!activeEdit.title"
              vs-type="filled"
              @click.prevent="showEditPost('title')"
              icon="edit"
            ></vs-button>
            &nbsp;&nbsp;
          </Tooltip>
        </span>
        <div class="edit-title" v-if="activeEdit.title">
          <vs-button
            vs-type="filled"
            @click.prevent="activeEdit.title = false"
            icon="close"
            class="close"
          ></vs-button>
          <vs-button
            vs-type="filled"
            @click.prevent="editPost('title')"
            icon="check"
            class="save"
          ></vs-button>
          
          <div class="textarea-emoji-picker" v-click-outside="hideEmojiPicker">
            <div class="styles-text-buttons" v-if="page.network !== 'bluesky'">
              <span @click="styleSelection('bold')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('bold') }">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#888888" d="M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z"/>
                </svg>
              </span>
              <span @click="styleSelection('italic')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('italic') }">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#888888" d="M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z "/>
                </svg>
              </span>
              <span @click="styleSelection('underline')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('underline') }">
                <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#888888" d="M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z"/>
                  <path fill="#888888" d="M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z"/>
                </svg>
              </span>
            </div>
            <picker
              v-if="page.network !== 'bluesky'"
              :data="emojiIndex"
              v-show="showEmojiPicker"
              title="Pick your emoji..."
              emoji="point_up"
              @select="addEmoji"
            />
            <span
              v-if="page.network !== 'bluesky'"
              class="emoji-trigger"
              :class="{ 'triggered': showEmojiPicker }"
              @click="toggleEmojiPicker"
            >
              <svg
                style="width:20px;height:20px"
                viewBox="0 0 24 24"
              >
                <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
              </svg>
            </span>
            <span class="add-mention" @click="toggleShowMentions('Mention')">@</span>
            <span class="add-mention add-hashtag" @click="toggleShowMentions('Hashtag')" :class="{ 'disabled': !activeSearchHashtags}">#</span>
            <span class="add-mention ai-generate" @click="getAccrochesByAI()"><span class="material-icons">lightbulb_outline</span></span>
            <vs-textarea 
              :class="{'input': true}"
              vs-size="large"
              color="#B20564"
              name="title"
              :placeholder="$t('dash.posts.overlay.description_placeholder')"
              v-model="editValue.title"
              :ref="`inputTitle-${page.network_id}`"
              :id="`inputTitle-${page.network_id}`"
              @click="[checkAddMention()]"
              @keyup="[checkTruncate(), checkAddMention(), textAreaAdjust(`inputTitle-${page.network_id}`)]"
            />
            <div class="vs-textarea--count" v-if="limitText()">
              {{ sizeCurrentMessage() }} / {{ limitText() }}
            </div>   
          </div>
        </div>
      </div>
      <div v-if="(image || post.video || (post.page && post.page[0] && (post.page[0].enclosure || post.page[0].video))) && post.url && !['instagram', 'google', 'pinterest'].includes(page.network)">
        &nbsp;
        <a :href="getUrlWithUtm" target="blank">
          <span>{{ getUrlWithUtm.substr(0, 42) }}...</span>
        </a>
      </div>
      
    </div>

    <a v-if="page.network === 'google' && getUrlWithUtm && getUrlWithUtm.length" :href="getUrlWithUtm" target="_blank" class="more">En savoir plus</a>

    <div class="description" v-else-if="['pinterest', 'youtube'].includes(page.network) && !getMessageToPostDescription(post) && getMessageToPostDescription(post) != 'null'">
      <span v-html="handleNewLine(getMessageToPostDescription(post), false, false, true)"></span>
    </div>

    <div class="comments" :class="{live}" v-if="post.status != 'direct' && ['instagram', 'facebook', 'linkedin', 'twitter', 'bluesky'].includes(page.network) && !(page.network == 'instagram' && typePost=='story') && ((post.page && post.page[0] && post.page[0].comments) || (post.comments && post.comments.length))">
      <ul>
        <li class="comment" :class="{live}" v-for="(comment, idx) in post.page && post.page[0] && post.page[0].comments ? post.page[0].comments.data : post.comments" :key="idx" v-show="comment !== '' && (editValue['comment'] && editValue['comment'][idx] !== false)">
          <page-image-avatar :page="page" v-if="page.network !== 'twitter'"/>
          <div class="content">
            <p class="page-name">{{`${page.network === 'twitter' ? '@':''}${page.name}`}}</p>
            <p class="message" v-html="handleNewLine(editValue['comment'] && editValue['comment'][idx] ? editValue['comment'][idx] : (editPostValue && editPostValue.filter(e => e.page === page.id)[0] && editPostValue.filter(e => e.page === page.id)[0]['comment'] && editPostValue.filter(e => e.page === page.id)[0]['comment'][idx]? editPostValue.filter(e => e.page === page.id)[0]['comment'][idx] : comment), false, true)" @click.prevent="live && (activeEdit.comment === false || activeEdit.comment !== idx) ? showEditPost('comment', idx) : null"></p>
            <div v-if="live && !doScreenshot && comment != ''" class="live-title">
              <span class="btn-edit">
                <Tooltip
                  :text="$t('dash.post.overlay.edit.comment')"
                  position="top"
                >
                  <vs-button
                    v-show="activeEdit.comment === false || activeEdit.comment !== idx"
                    vs-type="filled"
                    @click.prevent="showEditPost('comment', idx)"
                    icon="edit"
                  ></vs-button>
                  &nbsp;&nbsp;
                </Tooltip>

                <Tooltip
                  :text="$t('dash.post.overlay.edit.comment.remove')"
                  position="top"
                >
                  <vs-button
                    v-show="activeEdit.comment === false || activeEdit.comment !== idx"
                    vs-type="filled"
                    @click.prevent="removeComment(idx)"
                    icon="close"
                    class="close"
                  ></vs-button>
                </Tooltip>
              </span>
              <div class="edit-title" v-if="activeEdit.comment !== false && activeEdit.comment == idx">
                <vs-button
                  vs-type="filled"
                  @click.prevent="activeEdit.comment = false"
                  icon="close"
                  class="close"
                ></vs-button>
                <vs-button
                  vs-type="filled"
                  @click.prevent="editPost('comment', null, idx)"
                  icon="check"
                  class="save"
                ></vs-button>
                
                <div class="textarea-emoji-picker" v-click-outside="hideEmojiPicker">
                  <!-- <div class="styles-text-buttons">
                    <span @click="styleSelection('bold')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('bold') }">
                      <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#888888" d="M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z"/>
                      </svg>
                    </span>
                    <span @click="styleSelection('italic')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('italic') }">
                      <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#888888" d="M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z "/>
                      </svg>
                    </span>
                    <span @click="styleSelection('underline')" class="emoji-trigger" :class="{ 'triggered': styledText().includes('underline') }">
                      <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#888888" d="M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z"/>
                        <path fill="#888888" d="M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z"/>
                      </svg>
                    </span>
                  </div> -->
                  <picker
                    v-if="page.network !== 'bluesky'"
                    :data="emojiIndex"
                    v-show="showEmojiPicker"
                    title="Pick your emoji..."
                    emoji="point_up"
                    @select="(e) => addEmoji(e,idx)"
                  />
                  <span
                    v-if="page.network !== 'bluesky'"
                    class="emoji-trigger"
                    :class="{ 'triggered': showEmojiPicker }"
                    @click="toggleEmojiPicker"
                  >
                    <svg
                      style="width:20px;height:20px"
                      viewBox="0 0 24 24"
                    >
                      <path fill="#888888" d="M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z" />
                    </svg>
                  </span>
                  <span class="add-mention" @click="toggleShowMentions('Mention', null, idx)">@</span>
                  <span class="add-mention add-hashtag" @click="toggleShowMentions('Hashtag', null, idx)" :class="{ 'disabled': !activeSearchHashtags}">#</span>
                  <!-- <span class="add-mention ai-generate" @click="getAccrochesByAI()"><span class="material-icons">lightbulb_outline</span></span> -->
                  <vs-textarea 
                    :class="{'input': true}"
                    vs-size="large"
                    color="#B20564"
                    name="title"
                    :placeholder="$t('dash.posts.overlay.description_placeholder')"
                    v-model="editValue.comment[idx]"
                    :ref="`inputComment-${idx}-${page.network_id}`"
                    :id="`inputComment-${idx}-${page.network_id}`"
                    @click="[checkAddMention(null, idx)]"
                    @keyup="[checkAddMention(null, idx), textAreaAdjust(`inputComment-${idx}-${page.network_id}`)]"
                  /> 
                  <!-- <div class="vs-textarea--count" v-if="limitText()">
                    {{ sizeCurrentMessage() }} / {{ limitText() }}
                  </div>   -->
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="comments" v-if="['facebook', 'linkedin', 'twitter', 'bluesky'].includes(page.network) && isPreviewLinkInComments()">
      <ul>
        <li class="comment">
          <page-image-avatar :page="page"/>
          <div class="content">
            <p class="page-name">{{`${page.network === 'twitter' ? '@':''}${page.name}`}}</p>
            <p class="message">
              <a :href="this.getUrlWithUtm" target="_blank">{{ this.getUrlWithUtm.substr(0, 42) }}...</a>
            </p>
          </div>
        </li>
      </ul>
    </div>

    <div v-if="['telegram', 'instagram', 'whatsapp', 'bluesky'].includes(page.network)" :class="[{'bottom-right': page.network === 'telegram', 'bottom-left': ['instagram', 'whatsapp'].includes(page.network), live}]">
      <div class="cta" v-if="!moderation && page.network === 'telegram'">
            <svg enable-background="new 0 0 32 32" id="Editable-line" version="1.1" viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path d="  M16,7C9.934,7,4.798,10.776,3,16c1.798,5.224,6.934,9,13,9s11.202-3.776,13-9C27.202,10.776,22.066,7,16,7z" fill="#B8B8B8" id="XMLID_10_" stroke="#B8B8B8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" />
              <circle cx="16" cy="16" fill="none" id="XMLID_12_" r="5" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" />
            </svg> <span class="telegram-view">1</span>
      </div>
      <p class="date" v-if="moderation">
        <Tooltip
            :text="dateFormat(post.date)"
            position="top"
          >
            <span>{{ dateFromNow(post.date) }}</span>
            &nbsp;
          </Tooltip>
      </p>
      <p class="date" v-else @click.prevent="live && !activeEdit.scheduling && isUserPremiumActive ? showEditPost('scheduling') : null">
        {{ postDate }}
        <span class="btn-edit" v-if="live && !doScreenshot">
          <Tooltip
            :text="$t('dash.post.overlay.edit.date')"
            position="top"
          >
            <vs-button
              v-show="live && !activeEdit.scheduling && isUserPremiumActive"
              vs-type="filled"
              @click.prevent="showEditPost('scheduling')"
              icon="edit"
            ></vs-button>
            &nbsp;&nbsp;
          </Tooltip>
        </span>
      </p>
      <div v-if="live && activeEdit.scheduling" class="live-scheduling schedule">
        <div class="schedule-wrapper">
          <div class="edit-scheduling">
            <component-datepicker
              class="posts-datepicker"
              v-on:picked="picked"
              :date="new Date(editValue.scheduling.date)"
              :now="true"
            ></component-datepicker>
            <div class="posts-timepicker">
              <img src="../../assets/img/icon_time_black.svg" alt="time">
              <vue-timepicker v-model="editValue.scheduling.time" :hour-range="rangeHour" :minute-range="rangeMinute" @change="changeRangeSchedulingTime" auto-scroll :minute-interval="minuteInterval"></vue-timepicker>
            </div>
            <vs-button
              vs-type="filled"
              @click.prevent="activeEdit.scheduling = false"
              icon="close"
            ></vs-button>
            <vs-button
              vs-type="filled"
              @click.prevent="editPost('scheduling')"
              icon="check"
            ></vs-button>
          </div>
        </div>
      </div>
      <div class="cta" v-if="page.network === 'bluesky' && !moderation && !disableCTA">
        <template>
          <svg fill="none" width="18" viewBox="0 0 24 24" height="18" style="color: rgb(111, 134, 159); pointer-events: none;"><path fill="hsl(211, 20%, 53%)" fill-rule="evenodd" clip-rule="evenodd" d="M2.002 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H12.28l-4.762 2.858A1 1 0 0 1 6.002 21v-2h-1a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v1.234l3.486-2.092a1 1 0 0 1 .514-.142h7a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-14Z"></path></svg>
          <svg fill="none" width="18" viewBox="0 0 24 24" height="18" style="color: rgb(111, 134, 159);"><path fill="hsl(211, 20%, 53%)" fill-rule="evenodd" clip-rule="evenodd" d="M17.957 2.293a1 1 0 1 0-1.414 1.414L17.836 5H6a3 3 0 0 0-3 3v3a1 1 0 1 0 2 0V8a1 1 0 0 1 1-1h11.836l-1.293 1.293a1 1 0 0 0 1.414 1.414l2.47-2.47a1.75 1.75 0 0 0 0-2.474l-2.47-2.47ZM20 12a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H6.164l1.293 1.293a1 1 0 1 1-1.414 1.414l-2.47-2.47a1.75 1.75 0 0 1 0-2.474l2.47-2.47a1 1 0 0 1 1.414 1.414L6.164 17H18a1 1 0 0 0 1-1v-3a1 1 0 0 1 1-1Z"></path></svg>
          <svg fill="none" width="18" viewBox="0 0 24 24" height="18" style="color: rgb(111, 134, 159); pointer-events: none;"><path fill="hsl(211, 20%, 53%)" fill-rule="evenodd" clip-rule="evenodd" d="M16.734 5.091c-1.238-.276-2.708.047-4.022 1.38a1 1 0 0 1-1.424 0C9.974 5.137 8.504 4.814 7.266 5.09c-1.263.282-2.379 1.206-2.92 2.556C3.33 10.18 4.252 14.84 12 19.348c7.747-4.508 8.67-9.168 7.654-11.7-.541-1.351-1.657-2.275-2.92-2.557Zm4.777 1.812c1.604 4-.494 9.69-9.022 14.47a1 1 0 0 1-.978 0C2.983 16.592.885 10.902 2.49 6.902c.779-1.942 2.414-3.334 4.342-3.764 1.697-.378 3.552.003 5.169 1.286 1.617-1.283 3.472-1.664 5.17-1.286 1.927.43 3.562 1.822 4.34 3.764Z"></path></svg>
          <svg fill="none" width="18" viewBox="0 0 24 24" height="18" style="color: rgb(111, 134, 159); pointer-events: none;"><path fill="hsl(211, 20%, 53%)" fill-rule="evenodd" clip-rule="evenodd" d="M12.707 3.293a1 1 0 0 0-1.414 0l-4.5 4.5a1 1 0 0 0 1.414 1.414L11 6.414v8.836a1 1 0 1 0 2 0V6.414l2.793 2.793a1 1 0 1 0 1.414-1.414l-4.5-4.5ZM5 12.75a1 1 0 1 0-2 0V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7.25a1 1 0 1 0-2 0V19H5v-6.25Z"></path></svg>
          <svg fill="none" viewBox="0 0 24 24" width="18" height="18" style="pointer-events: none;"><path fill="hsl(211, 20%, 53%)" fill-rule="evenodd" clip-rule="evenodd" d="M2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm16 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"></path></svg>
        </template>
      </div>

      <div v-if="page.network === 'instagram' && shareAfterPost && page.story_config && page.story_config.created">
        <div class="vertical-line"><span>Storification</span></div>
        <!-- <story :class="!live && 'storification-preview-size'"
          :storification="{
            image: (carouselData && carouselData[0] && carouselData[0].url) || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: page.name,
            isCarousel: multipleImages && multipleImages.length > 1
          }"
          :link="{
            url: post.url,
            initialDatas: $store.getters['storificationLinkText'],
            isActive: $store.getters['storificationLinkIsActive'],
            text: $store.getters['storificationLinkText'],
          }"
          :preview="live ? null : {
            'Link': $store.getters['storificationLinkText']
          }"
          :informations="{
          }"
          >
        </story> -->
        <story :class="!live && 'storification-preview-size'"
          :storification="{
            video: (post.video && !(multipleMedias && multipleMedias.length > 1)) || (multipleMedias && multipleMedias[0] && multipleMedias[0].type.includes('video') && multipleMedias[0].url),
            image: (multipleMedias && multipleMedias[0] && multipleMedias[0].type.includes('image') && multipleMedias[0].url) || (carouselData && carouselData[0] && carouselData[0].url) || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: page.name,
            isCarousel: (multipleImages && multipleImages.length > 1) || (carouselData && carouselData.length > 1) || (multipleMedias && multipleMedias.length > 1 && !multipleMedias[0].type.includes('video'))
          }"
          :backgroundColor="$store.getters.storificationBackgroundColor"
          :link="{
            url: post.url,
            initialDatas: $store.getters.storificationLink,
            isActive: $store.getters.storificationLinkIsActive,
            text: $store.getters.storificationLinkText,
          }"
          :texts="$store.getters.storificationTexts"
          :layers="$store.getters.storificationLayers"
          :gifs="$store.getters.storificationGifs"
          :music="$store.getters.storificationMusic"
          :location="$store.getters.storificationLocation"
          :product="$store.getters.storificationProduct"
          :poll="$store.getters.storificationPoll"
          :slider="$store.getters.storificationSlider"
          :mentions="$store.getters.storificationMentions"
          :hashtags="$store.getters.storificationHashtags"
          :question="$store.getters.storificationQuestion"
          :template="{
            config: $store.getters.storificationTemplate,
            custom: currentBot ? currentBot.storyTemplate : null
          }"
          :preview="(live && index === 0) ? null : {
            'Link': $store.getters.storificationLink,
            'Text': $store.getters.storificationTexts,
            'Layer': $store.getters.storificationLayers,
            'Gif': $store.getters.storificationGifs,
            'Poll': $store.getters.storificationPoll,
            'Slider':$store.getters.storificationSlider,
            'Mention': $store.getters.storificationMentions,
            'Hashtag': $store.getters.storificationHashtags,
            'Location': $store.getters.storificationLocation,
            'Product': $store.getters.storificationProduct,
            'Question': $store.getters.storificationQuestion,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
      </story>
        <!-- <div class="preview-share-after-post background-img">
          <img crossorigin="anonymous" v-if="" class="share-img" :src="post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.og.images.length > 0 && meta.og.images[0].url) || (meta && meta.images && meta.images[0] && meta.images[0].url)" alt="" @load="shareLoadImage" @error="shareLoadErrorImage">
          <p class="share-username" v-if="post.enclosure || image || (meta && meta.images && meta.images[0] && meta.images[0].url) || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url)">@{{page.name}}</p>
          <img :hidden="!multipleImages || multipleImages.length <= 1" class="carousel-storification" src="../../assets/img/carousel.svg"/>
          <div v-if="post.url" :class="`link-container-view style-link${0}`"> 
            <img class="link-img" src="../../assets/img/icon_instagram_link.svg" alt="Link">
            <p class="link-txt">{{post.url.split('/')[2].toUpperCase().split('?')[0].replace('WWW.', '')}}</p>
          </div>
        </div> -->
      </div>
      <p class="date" v-if="page.network === 'instagram' && shareAfterPost && page.story_config && page.story_config.created" @click.prevent="live && !activeEdit.scheduling && isUserPremiumActive ? showEditPost('scheduling') : null">
        {{ postDateStorification }}
        <span class="btn-edit" v-if="live && !doScreenshot">
          <Tooltip
            :text="$t('dash.post.overlay.edit.date')"
            position="top"
          >
            <vs-button
              v-show="live && !activeEdit.scheduling && isUserPremiumActive"
              vs-type="filled"
              @click.prevent="showEditPost('scheduling')"
              icon="edit"
            ></vs-button>
            &nbsp;&nbsp;
          </Tooltip>
        </span>
      </p>
      <div v-if="live && activeEdit.scheduling && page.network === 'instagram' && shareAfterPost  && page.story_config && page.story_config.created" class="live-scheduling schedule">
        <div class="schedule-wrapper">
          <div class="edit-scheduling">
            <component-datepicker
              class="posts-datepicker"
              v-on:picked="(d) => picked(d, true)"
              :top="true"
              :date="new Date(editValue.storification.date)"
              :from="new Date(editValue.scheduling.date)"
            ></component-datepicker>
            <div class="posts-timepicker storification">
              <img src="../../assets/img/icon_time_black.svg" alt="time">
              <vue-timepicker drop-direction="up" v-model="editValue.storification.time" :hour-range="rangeHourStorification" :minute-range="rangeMinuteStorification" @change="changeRangeSchedulingTimeStorification" auto-scroll :minute-interval="minuteInterval"></vue-timepicker>
            </div>
            <vs-button
              vs-type="filled"
              @click.prevent="activeEdit.scheduling = false"
              icon="close"
            ></vs-button>
            <vs-button
              vs-type="filled"
              @click.prevent="editPost('scheduling', true)"
              icon="check"
            ></vs-button>
          </div>
        </div>
      </div>
      <div v-if="page.network === 'instagram' && storyShareToFacebook && page.story_config && page.story_config.created">
        <div class="vertical-line"><span>Facebook</span></div>
        <!-- <story :class="!live && 'storification-preview-size'"
          :storification="{
            image: (carouselData && carouselData[0] && carouselData[0].url) || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) || (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: page.name,
            isCarousel: multipleImages && multipleImages.length > 1,
          }"
          :link="{
            url: post.url,
            initialDatas: $store.getters['storificationLinkText'],
            isActive: $store.getters['storificationLinkIsActive'],
            text: $store.getters['storificationLinkText']
          }"
          :preview="{
            'Link': $store.getters['storificationLinkText'],
          }"
          
        >
        </story>

        -->
         <story :class="!live && 'storification-preview-size'"
          :story="!(storificationObject || shareAfterPost) ? {
            image: imageStory,
            video: videoStory
          } : undefined"
          :storification="(storificationObject || shareAfterPost) ? {
            video: (post.video && !(multipleMedias && multipleMedias.length > 1)) || (multipleMedias && multipleMedias[0] && multipleMedias[0].type.includes('video') && multipleMedias[0].url),
            image: (multipleMedias && multipleMedias[0] && multipleMedias[0].type.includes('image') && multipleMedias[0].url) || (carouselData && carouselData[0] && carouselData[0].url) || post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url) ||  (meta && meta.images && meta.images[0] && meta.images[0].url),
            username: page.name,
            isCarousel: (multipleImages && multipleImages.length > 1) || (carouselData && carouselData.length > 1) || (multipleMedias && multipleMedias.length > 1 && !multipleMedias[0].type.includes('video'))
          } : undefined"
          :backgroundColor="$store.getters.storificationBackgroundColor"
          :link="{
            url: post.url,
            initialDatas: $store.getters.storificationLink,
            isActive: $store.getters.storificationLinkIsActive,
            text: $store.getters.storificationLinkText,
          }"
          :texts="$store.getters.storificationTexts"
          :layers="$store.getters.storificationLayers"
          :gifs="$store.getters.storificationGifs"
          :location="$store.getters.storificationLocation"
          :product="$store.getters.storificationProduct"
          :music="$store.getters.storificationMusic"
          :poll="$store.getters.storificationPoll"
          :slider="$store.getters.storificationSlider"
          :mentions="$store.getters.storificationMentions"
          :hashtags="$store.getters.storificationHashtags"
          :question="$store.getters.storificationQuestion"
          :template="{
            config: $store.getters.storificationTemplate,
            custom: currentBot ? currentBot.storyTemplate : null
          }"
          :preview="{
            'Link': $store.getters.storificationLink,
            'Text': $store.getters.storificationTexts,
            'Layer': $store.getters.storificationLayers,
            'Gif': $store.getters.storificationGifs,
            'Poll': $store.getters.storificationPoll,
            'Slider':$store.getters.storificationSlider,
            'Mention': $store.getters.storificationMentions,
            'Hashtag': $store.getters.storificationHashtags,
            'Location': $store.getters.storificationLocation,
            'Product': $store.getters.storificationProduct,
            'Question': $store.getters.storificationQuestion,
          }"
          :informations="{
            mentions: currentBot,
            acceptReplaceHashtag: activeHashtagsAutoAdd,
            validMentions: validMentions,
            validHashtags: validHashtags,
            acceptPrefix: activePrefixSuffix,
            pageInfo: page,
            highlight: highlightStoryEnable
          }"
          >
      </story>

        <!-- <div class="preview-share-after-post background-img">
          <img crossorigin="anonymous" v-if="post.enclosure || image || (meta && meta.images && meta.images[0] && meta.images[0].url) || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url)" class="share-img" :src="post.enclosure || image || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.og.images.length > 0 && meta.og.images[0].url) || (meta && meta.images && meta.images[0] && meta.images[0].url)" alt="" @load="shareLoadImage" @error="shareLoadErrorImage">
          <p class="share-username" v-if="post.enclosure || image || (meta && meta.images && meta.images[0] && meta.images[0].url) || (meta && meta.og && meta.og.image) || (meta && meta.og && meta.og.images && meta.images[0] && meta.images[0].url)">@{{page.name}}</p>
          <img :hidden="!multipleImages || multipleImages.length <= 1" class="carousel-storification" src="../../assets/img/carousel.svg"/>
        </div> -->
      </div>
      <p class="date" v-if="page.network === 'instagram' && shareAfterPost && storyShareToFacebook && page.story_config && page.story_config.created">
        {{ postDateStorification }}
      </p>
      
    </div>
    <vs-prompt class="auto-generate-text"
      v-if="live"
      :title="$t('dash.auto-generate-text.title')"
      color="info"
      @cancel="() => {openAccrochesAI = false; accrochesAI=null}"
      @accept="changeTextByGenerated()"
      @close="() => {openAccrochesAI = false; accrochesAI=null}"
      :active.sync="openAccrochesAI">
      <div class="con-exemple-prompt">
        <ul>
          <li v-for="(opt, idx) in accrochesAI" :key="idx">
            <input
              type="checkbox"
              :id="`accroche-${idx}`"
              name="accroches[]"
              :value="opt"
              v-model="selectedAccroches"
            >  
            {{ opt }}
          </li>
        </ul>
      </div>
    </vs-prompt>
  </div>    
</template>

<script>
import moment from 'moment'
import LinkPrevue from 'link-prevue'
import Posts from './../mixins/Posts'
import Insights from './../mixins/Insights'
import Pages from './../mixins/Pages'
import Notif from './../mixins/Notif'
import User from './../mixins/User.vue'
import PreviewPost from './PreviewPost.vue'
import StoryMaker from './StoryMaker.vue'
import Moderation from './../mixins/Moderation'
import componentTemplateMaker from './TemplateMaker.vue'
import PageImageAvatar from './PageImageAvatar.vue'
import imgDefault from '../../assets/img/no-picture.png'
import VueTimepicker from 'vue2-timepicker'
import componentDatepicker from './Datepicker.vue'
  import emojiData from '@/constants/emoji-mart-vue-fast/all.json'
  import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
  import 'emoji-mart-vue-fast/css/emoji-mart.css'
  import ClickOutside from 'vue-click-outside'
import pdf from 'pdfvuer'
import { Carousel, Slide } from 'vue-carousel';
import draggable from 'vuedraggable'
import Fonts from '../../utils/Fonts'
import componentLoader from './overlay/Loader.vue'
import ColorThief from 'color-thief-browser'
import Tooltip from './tooltip/tooltipInit.vue'
import Storification from './Storification.vue'
import Story from './Story.vue'
import { resolveVariables } from '@/utils/resolveVariables.js'

export default {
  name: 'preview-post',

  components: {
    LinkPrevue,
    PreviewPost,
    StoryMaker,
    componentTemplateMaker,
    PageImageAvatar,
    VueTimepicker,
    componentDatepicker,
    Picker,
    pdf,
    Carousel,
    Slide,
    draggable,
    componentLoader,
    Tooltip,
    Storification,
    Story
  },

  mixins: [Posts, Insights, Pages, Moderation, Notif, User],

  directives: {
    ClickOutside
  },

  props: {
    index: Number,
    storificationObject: null,
    userTags: null,
    productTags: null,
    location: null,
    injectedSnippetTitle: String | null,
    injectedSnippet: String | null,
    multipleImages: Array,
    multipleMedias: Array,
    page: Object,
    post: Object,
    reshare: Object,
    resharePage: Object,
    retweet: Object,
    image: String,
    moderation: Boolean,
    activeMentionsAutoReplace: Boolean,
    activeHashtagsAutoAdd: Boolean,
    activePrefixSuffix: Boolean,
    disableCTA: Boolean,
    validMentions: Array,
    validHashtags: Array,
    typePost: String,
    live: Boolean,
    showLive: Boolean,
    editPostValue: Array,
    schedulingOverlay: Object,
    currentPostFieldEdit: Object,
    pdfTitle: String,
    poll: Object,
    metas: Object,
    previewEdited: Object,
    shareAfterPost: Boolean,
    storyShareToFacebook: Boolean,
    videoReel: Boolean,
    compressedImages: Array | null,
    highlightStoryEnable: {
      type: Boolean,
      default: false
    },
    doScreenshot: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      multipleImagesPreview: [],
      multipleImagesOriginal: [],
      carrouselInitialSwipe: [],
      carrouselTimeDrag: true,
      carrouselTimeOut: null,
      locationName: this.$t("dash.posts.status.inqueue") + '...',
      pdfReset: true,
      snippetTitle: '',
      snippetData: null,
      meta: null,
      bot: null,
      message: null,

      pdfPage: 1,
      pdfPageNumber: 0,

      activeEdit: {
        title: false,
        scheduling: false,
        comment: false
      },
      editValue: {
        storification: {
          date: moment().add(2, 'minutes').second(0).utc().local().format(),
          time: {
            HH: moment().add(2, 'minutes').utc().local().hour() < 10 
                                    ? `0${moment().add(2, 'minutes').utc().local().hour()}`
                                    : `${moment().add(2, 'minutes').utc().local().hour()}`,
            mm: moment().add(2, 'minutes').utc().local().minute() < 10 
                                    ?`0${moment().add(2, 'minutes').utc().local().minute()}`
                                    : `${moment().add(2, 'minutes').utc().local().minute()}`
          }
        },
        title: null,
        scheduling: {
          date: moment().add(2, 'minutes').second(0).utc().local().format(),
          time: {
            HH: moment().add(2, 'minutes').utc().local().hour() < 10 
                                    ? `0${moment().add(2, 'minutes').utc().local().hour()}`
                                    : `${moment().add(2, 'minutes').utc().local().hour()}`,
            mm: moment().add(2, 'minutes').utc().local().minute() < 10 
                                    ?`0${moment().add(2, 'minutes').utc().local().minute()}`
                                    : `${moment().add(2, 'minutes').utc().local().minute()}`
          }
        },
        comment: {}
      },

      rangeHour: [[moment().minute()+2 >= 60 ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) : moment().hour(), 23]],
      rangeMinute: [[moment().minute()+2 >= 60 ? moment().minute()+2-60 : moment().minute()+2, 59]],
      rangeHourStorification: [[moment().minute()+2 >= 60 ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) : moment().hour(), 23]],
      rangeMinuteStorification: [[moment().minute()+2 >= 60 ? moment().minute()+2-60 : moment().minute()+2, 59]],
      // rangeMinuteStorification: [[1, 59]],
      minuteInterval: 1,

      emojiIndex: new EmojiIndex(emojiData),
      showEmojiPicker: false,

      counterDanger: false,
      textTruncated: false,
      showLoader: false,

      accrochesAI: null,
      openAccrochesAI: false,
      selectedAccroches: [],
      linkedinVanityName: null
    }
  },

  async mounted(){
    moment.locale(this.$i18n.locale)
    this.bot = this.post && this.post._bots && this.post._bots.page && this.post._bots.page.id == this.page.id ? this.post._bots : (localStorage.bots ? JSON.parse(localStorage.bots).find(b => b.page.id == this.page.id) : [])
    this.getMeta()

    if (this.post && this.post.flux && this.post.page && this.post.page[0] && !this.post.page[0].isManualPost && this.post.page[0].story) {
      const storyObject = JSON.parse(this.post.page[0].story)
      console.log(this.post.page[0].story, storyObject)
      if (storyObject && storyObject.templateAuto && storyObject.templateAuto.configuration) {
        if (storyObject.templateAuto.configuration.text) {
          let width = Math.min(360, storyObject.texts[0].text.length * ((storyObject.templateAuto.configuration.text.size) - 3)/2)
          let height = ((storyObject.texts[0].text.length * ((storyObject.templateAuto.configuration.text.size) - 3)/2)/360) * 25
          this.$store.commit("addStorificationText", {
            angle: 0,
            background: storyObject.templateAuto.configuration.text.background || 0,
            color: storyObject.templateAuto.configuration.text.color,
            content: storyObject.texts[0].text,
            font: storyObject.templateAuto.configuration.text.font,
            h: height,
            scale: 1,
            size: (storyObject.templateAuto.configuration.text.size) - 3,
            visible:true,
            w: width,
            x: ((storyObject.templateAuto.configuration.text.x / 4) - (width/2)),
            y: ((storyObject.templateAuto.configuration.text.y / 4) - (height/2)),

          })
        }
        if (storyObject.templateAuto.configuration.link) {
          this.$store.commit("updateStorificationLink",{
            active: true,
            angle: 0,
            color: 0,
            text: storyObject.templateAuto.configuration.link.custom_cta || null,
            h: storyObject.templateAuto.configuration.link.h/4,
            index: null,
            scale: 1,
            w: storyObject.templateAuto.configuration.link.w/4,
            x: ((storyObject.templateAuto.configuration.link.x / 4) - (storyObject.templateAuto.configuration.link.w / 3 / 2)),
            y: ((storyObject.templateAuto.configuration.link.y / 4) - (storyObject.templateAuto.configuration.link.h / 4 / 2))
          })
        }
        if (storyObject.templateAuto.configuration.background) {
          this.$store.commit("updateStorificationBackgroundColor", storyObject.templateAuto.configuration.background)
        }
        if (storyObject.templateAuto.configuration.layers) {
          this.$store.commit("updateStorificationLayers", storyObject.templateAuto.configuration.layers.map(layer => {
            return {
              url: layer.url,
              x: layer.x/3,
              y: layer.y/3,
              w: layer.w/3,
              h: layer.h/3,
              angle: 0,
              color: 0,
              scale: 1,
            }
          }))
        }
      }
    }

    this.editValue.title = null;

    if (this.editPostValue) {
      let idxEPV = this.editPostValue.findIndex(e => e.page === this.page.id)
      if (idxEPV >= 0 && this.editPostValue[idxEPV] && this.editPostValue[idxEPV].scheduling) {
        this.editValue.scheduling = this.editPostValue[idxEPV].scheduling;
        if (this.editPostValue[idxEPV].storification) {
          this.editValue.storification = this.editPostValue[idxEPV].storification;
        }
      }
    }
    
    if(this.schedulingOverlay && this.schedulingOverlay.show) {
      this.$set(this.editValue, 'scheduling', {
        date: this.schedulingOverlay.date,
        time : {
          HH: this.schedulingOverlay.time.HH,
          mm: this.schedulingOverlay.time.mm
        }
      })

      if(moment(this.editValue.scheduling.date).isAfter(moment().hours(23).minutes(59).seconds(59))) {
        this.rangeHour = [[0, 23]]
        this.rangeMinute = [[0, 59]]
        this.rangeHourStorification = [[0, 23]]
        this.rangeMinuteStorification = [[0, 59]]
      }
    }
    
    if (this.post.page && this.post.page[0] && this.post.page[0].location) {
      this.getInstagramPageName(this.page.id, this.post.page[0].location).then(e => {
          this.locationName = e.body.name;
      });
    }
    this.multipleImagesPreview = this.multipleImages ? this.multipleImages.map(e => {
      let fileTemp = new File([e.file], e.file.name, { type: e.file.type } );
      let copy = JSON.parse(JSON.stringify(e));
      copy.file = fileTemp;
      return copy;
    }) : []
    // this.multipleImagesPreview = this.multipleImages ? JSON.parse(JSON.stringify(this.multipleImages)) : []

    if(/^[0-9]+$/.test(this.page.network_id) == false){
      let res = await this.linkedinProfile(this.page.id)
      if(res && res.body.linkedinProfile && res.body.linkedinProfile.vanityName) 
        this.linkedinVanityName = res.body.linkedinProfile.vanityName
    }
  },

  methods: {

    checkEditImage() {
      if(this.page.network == 'facebook')
        return this.multipleImages.find(m => m.facebookOrdered)

      else if(this.page.network == 'linkedin')
        return this.multipleImages.find(m => m.linkedinOrdered)
        
      else if(this.page.network == 'twitter')
        return this.multipleImages.find(m => m.twitterOrdered)

      return false
    },
    
    swapOrderCarousel(id1, id2) {
      // this.multipleImages = [...this.multipleImagesOriginal]
      // let arr = JSON.parse(JSON.stringify(this.multipleImagesOriginal))
      let arr = this.multipleImagesOriginal.map(e => {
        let fileTemp = new File([e.file], e.file.name, { type: e.file.type } );
        let copy = JSON.parse(JSON.stringify(e));
        copy.file = fileTemp;
        return copy;
      })
      let index1 = arr.findIndex(item => item.id == id1)
      let index2 = arr.findIndex(item => item.id == id2)
      if (index1 === this.carrouselInitialSwipe[0] && index2 === this.carrouselInitialSwipe[1]) {
        arr = this.multipleImagesOriginal;
      } else {
        this.carrouselInitialSwipe = [index1, index2]
        // console.log(orderTemp, orderTemp2);
        let temp = arr[index1]
        arr[index1] = arr[index2]
        arr[index2] = temp
      }  
      this.multipleImagesPreview = arr
    },

    swapOrderCarouselByNetwork(id1, id2, network) {
      // this.multipleImages = [...this.multipleImagesOriginal]
      // let arr = JSON.parse(JSON.stringify(this.multipleImagesOriginal)).map(e => {e[`${network}Ordered`] = true; return e;});
      let arr = this.multipleImagesOriginal.map(e => {
        let fileTemp = new File([e.file], e.file.name, { type: e.file.type } );
        let copy = JSON.parse(JSON.stringify(e));
        copy.file = fileTemp;
        copy[`${network}Ordered`] = true;
        return copy;
      })
      let orderTemp = arr.find(item => item.id == id1)[network]
      let orderTemp2 = arr.find(item => item.id == id2)[network]
      // console.log(orderTemp, orderTemp2, this.carrouselInitialSwipe);
      if (orderTemp === this.carrouselInitialSwipe[0] && orderTemp2 === this.carrouselInitialSwipe[1]) {
        arr = this.multipleImagesOriginal;
        this.carrouselInitialSwipe = [];
      } else {
        this.carrouselInitialSwipe = [orderTemp, orderTemp2]
        arr.find(item => item.id == id1)[network] = orderTemp2;
        arr.find(item => item.id == id2)[network] = orderTemp;
      }      
      this.multipleImagesPreview = arr
    },

    dragOrderCarouselStart(e) {
      console.log("Start");
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.dropEffect = 'move';
      this.carrouselInitialSwipe = [];
      this.carouselOrderDragElement = e.target;
      // this.multipleImagesOriginal = JSON.parse(JSON.stringify(this.multipleImagesPreview));
      this.multipleImagesOriginal = this.multipleImagesPreview.map(e => {
        let fileTemp = new File([e.file], e.file.name, { type: e.file.type } );
        let copy = JSON.parse(JSON.stringify(e));
        copy.file = fileTemp;
        return copy;
      })

    },

    dragOrderCarousel(e, network) {
      e.preventDefault();
      if (!this.carrouselTimeDrag) return;
      clearTimeout(this.carrouselTimeOut);
      this.carrouselTimeDrag = false;
      console.log("DRAG");
      e.preventDefault();
      let originX = e.clientX;
      let originY = e.clientY;
      let a = document.elementFromPoint(originX, originY);
      // if (a.tagName === "IMG") {
      //   a.style.border = '4px solid #6A1F4C';
      // }
      if (this.carouselOrderDragElement.id && a.id && this.carouselOrderDragElement.id !== a.id) {
        // console.log(this.carouselOrderDragElement.id , a.id);
        if (network) {
          this.swapOrderCarouselByNetwork(this.carouselOrderDragElement.id, a.id, network)
        } else {
          this.swapOrderCarousel(this.carouselOrderDragElement.id, a.id);
        }
      }
      this.carrouselTimeOut = setTimeout(() => {
        this.carrouselTimeDrag = true;
      }, 500)
    },

    dragOrderCarouselStop(e) {
      e.preventDefault();
      this.carrouselTimeDrag = true
      // this.multipleImagesOriginal = JSON.parse(JSON.stringify(this.multipleImages));
      let originX = e.clientX;
      let originY = e.clientY;
      let a = document.elementFromPoint(originX, originY);
      // console.log(a);
      a.style.border = 'none';
      // if (this.carouselOrderDragElement.id && a.id && this.carouselOrderDragElement.id !== a.id) {
      //   if (network) {
      //     this.swapOrderCarouselByNetwork(this.carouselOrderDragElement.id, a.id, network)
      //   } else {
      //     this.swapOrderCarousel(this.carouselOrderDragElement.id, a.id);
      //   }
      // }
      this.carouselOrderDragElement = null;

      // SEND TO POST OVERLAY NEW ARRAY ORDER
      this.$emit("updateMultipleImages", this.multipleImagesPreview)
    },

    dragCarouselLeave(e) {
      console.log("LEAVE");
      let element = e.originalTarget || e.target
      element.style.border = "none";
      this.carrouselTimeDrag = true
      // console.log(element);
    },

    textAreaAdjust(element) {
      document.getElementById(element).style.height = "1px";
      document.getElementById(element).style.height = (25+document.getElementById(element).scrollHeight)+"px";
    },

    async getTiktokPageUrl(id) {
      this.getTiktokUrl(id).then(res => {
        if (res.ok && res.body.success) {
          const url = res.body.profile_deep_link;
          //open url in new tab
          window.open(url, '_blank');
        }
      });
    },

    async getAccrochesByAI() {
      let search = this.post.title
      if(!this.post.title.length && this.post.url.length && this.meta) {
        search = this.meta.og && this.meta.og.title ? this.meta.og.title : this.meta.meta.title
        search += `\n${this.meta.og && this.meta.og.description ? this.meta.og.description : this.meta.meta.description}`
      }

      if(search.length) {
        this.showLoader = true

        this.generateTextByAI(search, this.page.network).then(res => {
          
          this.showLoader = false

          if(res && res.body && res.body.success){
            this.accrochesAI = res.body.accoches
            this.openAccrochesAI = true
          }
          else
            this.notify({
              title:'Erreur',
              text:JSON.stringify(res.body),
              color:'success',
              time: 10000,
              id: this.page.id
            })
        })
      }
    },

    changeTextByGenerated() {
      this.editValue.title = ''
      this.selectedAccroches.forEach(accroche =>{
        this.editValue.title += accroche + '\n\n'
      })
      this.openAccrochesAI = false
      this.accrochesAI = null
    },

    shareLoadErrorImage(e, origin=false) {
      console.log("@error=shareLoadErrorImage origin:", origin);
      let img = e.target;
      if (origin) {
        img.crossOrigin = undefined;
      }
      img.onerror = () => this.shareLoadErrorImage(e, true);
      if (!img.src.includes("timestamp")) {
        img.src += `?timestamp=${new Date().getTime()}`
      }
      img.style.backgroundColor = 'white';
    },

    shareLoadImage(e) {
      let colors
      try {
        let colorThief = new ColorThief();
        colors = colorThief.getPalette(e.target, 5).map(c => {
          return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
        })
      } catch(err) {
        console.log(err);
        colors = [`rgb(0,0,0)`, `rgb(0,0,0)`]
      }
      e.target.parentElement.style =  `background: linear-gradient(${colors[0]}, ${colors[1]})`;
      e.target.nextSibling.style = `top: ${e.target.parentElement.offsetHeight/2 + e.target.height/2 + 10}px`;
      e.target.parentElement.getElementsByClassName("carousel-storification")[0].style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.height/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.width/2 - 30}px;`
      // e.target.parentElement.lastChild.style = `top: ${e.target.parentElement.offsetHeight/2 - e.target.height/2 + 7}px; left: ${e.target.parentElement.offsetWidth/2 + e.target.width/2 - 30}px;`
    },

    closeAutoMentions() {
      this.$emit('closeAutoMentions')
    },

    toggleShowMentions(type='Mention', idx=null, commentId=null) {    
        if(type == 'Hashtag' && !this.activeSearchHashtags) return
        
        let a = commentId != null && commentId >= 0 ? this.$refs[`inputComment-${commentId}-${this.page.network_id}`][0].$el.firstElementChild
                          : this.$refs[`inputTitle-${this.page.network_id}`].$el.firstElementChild
        let start = a.selectionStart;
        let end = a.selectionEnd;
        let message = commentId != null && commentId >= 0 ? this.editValue.comment[commentId] : this.editValue.title

        let previewEdited = { page: this.page }
        previewEdited[type.toLowerCase()] = {
          add: true,
          start: message.substr(0, start - 1),
          end: message.substr(end + 1),
          selected: start != end ? message.substr(start, end-start) : ''
        }
        if(commentId != null && commentId >= 0)
          previewEdited.commentId = commentId

        this.$emit('addMention', type, idx, commentId, previewEdited)
        this.editPost(commentId != null && commentId >= 0 ? 'comment' : 'title', null, commentId)
    },

    checkAddMention(idx=null, commentId=null) {
      let a = commentId != null && commentId >= 0 ? this.$refs[`inputComment-${commentId}-${this.page.network_id}`][0].$el.firstElementChild
                        : this.$refs[`inputTitle-${this.page.network_id}`].$el.firstElementChild
      let start = a.selectionStart;
      let end = a.selectionEnd;

      if(start == end){
        
        let regexMention = new RegExp('@\\[MENTIONS-\\b([0-9]|[1-9][0-9]|100)\\b(?!\\])'
                                + '|@\\[ENTiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MNTiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[METiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENiONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTONS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiNS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiOS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiON-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|@\\[MENTiONS\\b([0-9]|[1-9][0-9]|100)\\b\\]', 'g')

        let regexHashtag = new RegExp('#\\[HASHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b(?!\\])'
                                + '|#\\[ASHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HSHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HAHTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASTAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHAGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTGS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTAS-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTAG-\\b([0-9]|[1-9][0-9]|100)\\b\\]'
                                + '|#\\[HASHTAGS\\b([0-9]|[1-9][0-9]|100)\\b\\]', 'g')

        if(commentId != null && commentId >= 0)
          this.editValue.comment[commentId] = this.editValue.comment[commentId].replace(regexMention, "").replace(regexHashtag, "");
        else
          this.editValue.title = this.editValue.title.replace(regexMention, "").replace(regexHashtag, "");

        let message = commentId != null && commentId >= 0 ? ' ' + this.editValue.comment[commentId]
                                : ' ' + this.editValue.title
        let indexStartSpace = message.lastIndexOfRegex(/[\]\n ]/g, start)
        let indexEndSpace = message.indexOfRegex(/[\n ]/g, start)
        indexEndSpace = indexEndSpace >= 0 ? indexEndSpace : message.length - 1 
        let indexStartMentions = message.indexOf('@[', indexStartSpace)
        let indexEndMentions = message.indexOf(']', indexStartMentions)
        let indexStartHashtags = message.indexOf(`#[`, indexStartSpace)
        let indexEndHashtags = message.indexOf(']', indexStartHashtags)
        let mentions = null
        //edit mentions
        if((indexStartMentions <= start && indexEndMentions >= start) 
              && (indexStartMentions >= 0 && indexStartMentions < indexEndSpace) 
              && indexStartMentions < indexEndMentions 
              && ((this.editValue.title && this.editValue.title.substr(start - 1, 1) != "]" && this.editValue.title.substr(start - 2, 1) != "]")
                  || (commentId && this.editValue.comment && this.editValue.comment[commentId].substr(start - 1, 1) != "]" && this.editValue.comment[commentId].substr(start - 2, 1) != "]"))
            ){
          let index = parseInt(message.substr(indexStartMentions, indexEndMentions+2).replace('@[MENTIONS-', '').replace(']', ''))

          mentions = this.validMentions[index-1]
          this.$emit('editMention', 'Mention', idx, commentId, message, indexStartMentions, indexEndMentions, index, {
            page: this.page,
            mention: {
              edit: true,
              start: message.substr(0, indexStartMentions),
              end: message.substr(indexEndMentions+1),
              index: index
            },
            commentId
          })
          this.editPost(commentId != null && commentId >= 0 ? 'comment' : 'title', null, commentId)
        }
        //add mentions
        else if((this.editValue.title && this.editValue.title.substr(start - 1, 1) == "@" 
                  && this.editValue.title.substr(start - 1, 2) != "@[" 
                  && (start == 1 || [" ", "\n"].includes(this.editValue.title.substr(start - 2, 1))))
                || (commentId && this.editValue.comment && this.editValue.comment[commentId].substr(start - 1, 1) == "@" 
                  && this.editValue.comment[commentId].substr(start - 1, 2) != "@[" 
                  && (start == 1 || [" ", "\n"].includes(this.editValue.comment[commentId].substr(start - 2, 1))))) {  
          this.$emit('addMention', 'Mention', idx, commentId, {
            page: this.page,
            mention: {
              add: true,
              start: message.substr(0, start - 1),
              end: message.substr(end + 1),
              selected: start != end ? message.substr(start, end-start+1) : ''
            },
            commentId
          })
          this.editPost(commentId != null && commentId >= 0 ? 'comment' : 'title', null, commentId)
        }
        //edit hashtags
        else if((indexStartHashtags <= start && indexEndHashtags >= start) 
              && (indexStartHashtags >= 0 && indexStartHashtags < indexEndSpace) 
              && indexStartHashtags < indexEndHashtags 
              && ((this.editValue.title && this.editValue.title.substr(start - 1, 1) != "]" && this.editValue.title.substr(start - 2, 1) != "]")
                    || (commentId && this.editValue.comment && this.editValue.comment[commentId].substr(start - 1, 1) != "]" && this.editValue.comment[commentId].substr(start - 2, 1) != "]"))
            ){
          let index = parseInt(message.substr(indexStartHashtags, indexEndHashtags+2).replace('#[HASHTAGS-', '').replace(']', ''))

          mentions = this.validHashtags[index-1]
          this.$emit('editMention', 'Hashtag', idx, commentId, message, indexStartHashtags, indexEndHashtags, index, {
            page: this.page,
            hashtag: {
              edit: true,
              start: message.substr(0, indexStartHashtags),
              end: message.substr(indexEndHashtags+1),
              index: index
            },
            commentId
          })
          this.editPost(commentId != null && commentId >= 0 ? 'comment' : 'title', null, commentId)
        }
      }
    },

    styledText() {
      if ((!this.$refs[`inputTitle-${this.page.network_id}`] || !this.$refs[`inputTitle-${this.page.network_id}`].$el)) return '';
      let b = null;
      let a = this.$refs[`inputTitle-${this.page.network_id}`].$el.firstElementChild;
      if (a.selectionStart !== a.selectionEnd) {
        b = this.editValue.title.substring(a.selectionStart, a.selectionEnd);
      } else {
        if (!this.editValue.title.slice(a.selectionStart)) return '';
        if(this.editValue.title.slice(a.selectionStart).match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu))
          b = this.editValue.title.slice(a.selectionStart).match(/\p{Grapheme_Base}\p{Grapheme_Extend}+|\p{Grapheme_Base}/gu)[0];
      }
      return Fonts.styledText(b);
    },

    styleSelection(type) {

      let a = this.$refs[`inputTitle-${this.page.network_id}`].$el.firstElementChild;
      let start = a.selectionStart;
      let end = a.selectionEnd;
      let styled = '';
      if (start !== end && !Fonts.checkIfMention(this.editValue.title, start, end)) {
        switch (type) {
          case 'bold': styled = Fonts.bold(this.editValue.title.substring(start, end));
          break;
          case 'italic': styled = Fonts.italic(this.editValue.title.substring(start, end));
          break;
          case 'underline': styled = Fonts.underline(this.editValue.title.substring(start, end));
          break;
          default: styled = this.editValue.title.substring(start, end);
        }
        this.editValue.title = this.editValue.title.substring(0, start) + styled + this.editValue.title.substring(end);
      }
      a.focus();
      this.$nextTick(() => {
        a.setSelectionRange(start, start+styled.length);
      });
    },

    getUrlObjectSnippet(injectedSnippet) {
      if(injectedSnippet && typeof injectedSnippet == 'string' && injectedSnippet.includes('http'))
        return injectedSnippet
      return URL.createObjectURL(injectedSnippet)
    },

    goToLink(link) {
      if(link)
        window.open(link, '_blank');
    },

    videoRatio(e) {
      let video = e.target
      let ratio = video.videoWidth / video.videoHeight
      switch (this.page.network) {
        case 'twitter':
          if (ratio < 0.33) {
            video.style.aspectRatio = 1/3;
            video.style.backgroundColor = 'black';
          } else if (ratio > 3) {
            video.style.aspectRatio = 3;
            video.style.backgroundColor = 'black';
          }
        break;
        case 'instagram':
          if (ratio < 0.8) {
            video.style.aspectRatio = 4/5;
            video.style.backgroundColor = 'black';
          } else if (ratio > 1.77777777778) {
            video.style.aspectRatio = 16/9;
            video.style.backgroundColor = 'black';
          }
        break;
        case 'tiktok':
          video.style.aspectRatio = 9/16;
          video.style.backgroundColor = 'black';
        break;
      }
    },

    limitImage(){
      let img = this.$refs.imageRef
      if (img) {
        let ratio = img.naturalWidth / img.naturalHeight;
        if (['instagram'].includes(this.page.network)) {
          if (parseFloat(ratio) > 1.91) {
            img.style.aspectRatio = 1.91;
            img.style.objectFit = 'cover';
          } else if (parseFloat(ratio) < 0.8) {
            img.style.aspectRatio = 0.8;
            img.style.objectFit = 'cover';
          }
        }
      }
    },

    validateSnippetTitle(e){
      this.snippetTitle = this.$refs.snippetTitle.value;
      this.activeEdit.snippet_title = false; 
      this.$forceUpdate();
      this.$emit('changeSnippetTitle', this.snippetTitle);
    },

    selectLinkedinSnippet({target: {files}}) {
      let file = files[0];
      // this.$set(this.editValue, 'image', file);
      // this.$set(this.editValue, 'image', file);
      // this.$emit('editPostLive', this.page.id, 'imageBase64', file)
      this.$emit('changeSnippet',file);
      // this.$forceUpdate()

    },

    arrayChunk(arr, chunkSize) {
      let res = [];
      for (let i = 0, len = arr.length; i < len; i += chunkSize) {
        res.push(arr.slice(i, i + chunkSize));
      }
      return res;
    },

    removeHtml(str){
      let regex = /(<([^>]+)>)/ig
      return str ? str.replace(regex, "") : str;
    },

    toggleEmojiPicker (e) {
      this.showEmojiPicker = !this.showEmojiPicker
    },
    hideEmojiPicker() {
      this.showEmojiPicker = false
    },
    addEmoji (emoji, idx) {
      let textarea
      if(idx >= 0) {
        textarea = document.getElementById(`inputComment-${idx}-${this.page.network_id}`)
        const cursorPosition = this.getInputSelection(textarea);
        const start = this.editValue.comment[idx].substring(0, cursorPosition.start)
        const end = this.editValue.comment[idx].substring(cursorPosition.end)
        
        this.editValue.comment[idx] = start + emoji.native + end
      }
      else {
        textarea = document.getElementById(`inputTitle-${this.page.network_id}`)
        const cursorPosition = this.getInputSelection(textarea);
        const start = this.editValue.title.substring(0, cursorPosition.start)
        const end = this.editValue.title.substring(cursorPosition.end)
        
        this.editValue.title = start + emoji.native + end
      }
      
      textarea.focus()
      this.hideEmojiPicker()
    },

    /**
     * Return an 
     * @param {DOMElement} el A dom element of a textarea or input text.
     * @return {Object} reference Object with 2 properties (start and end) with the identifier of the location of the cursor and selected text.
     **/
    getInputSelection(el) {
      var start = 0, end = 0, normalizedValue, range,
          textInputRange, len, endRange;

      if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
          start = el.selectionStart;
          end = el.selectionEnd;
      } else {
          range = document.selection.createRange();

          if (range && range.parentElement() == el) {
              len = el.value.length;
              normalizedValue = el.value.replace(/\r\n/g, "\n");

              // Create a working TextRange that lives only in the input
              textInputRange = el.createTextRange();
              textInputRange.moveToBookmark(range.getBookmark());

              // Check if the start and end of the selection are at the very end
              // of the input, since moveStart/moveEnd doesn't return what we want
              // in those cases
              endRange = el.createTextRange();
              endRange.collapse(false);

              if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                  start = end = len;
              } else {
                  start = -textInputRange.moveStart("character", -len);
                  start += normalizedValue.slice(0, start).split("\n").length - 1;

                  if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                      end = len;
                  } else {
                      end = -textInputRange.moveEnd("character", -len);
                      end += normalizedValue.slice(0, end).split("\n").length - 1;
                  }
              }
          }
      }

      return {
          start: start,
          end: end
      };
    },

    /**
     * Date picked
     */
    picked(date, storification = false) {
      if (storification) {
        this.editValue.storification.date = date
      } else {
        if (moment(this.editValue.scheduling.date).hour(0).minute(0).second(0).unix() === moment(this.editValue.storification.date).hour(0).minute(0).second(0).unix()) {
          this.editValue.storification.date = date
        }
        this.editValue.scheduling.date = date
      }
      const today = moment().hour(0).minute(0).second(0)
      if(today.unix() == moment(date).unix()){
        this.rangeHour = [
          [
            moment().minute()+2 >= 60 
              ? (moment().hour()+1 > 23 ? 0 : moment().hour()+1) 
              : moment().hour(), 
            23
          ]
        ]
        this.rangeMinute = [
          [
            moment().minute()+2 >= 60 
              ? `0${moment().minute()+2-60}` 
              : moment().minute()+2, 
            59
          ]
        ]
      }
      else {
        this.rangeHour = [[0, 23]]
        this.rangeMinute = [[0, 59]]
      }
      if (this.page.network === 'instagram' && this.shareAfterPost) {
        let hour = this.editValue.scheduling.time.HH
        let minute = this.editValue.scheduling.time.mm
        if (moment(this.editValue.scheduling.date).hour(0).minute(0).second(0).unix() == moment(date).unix()){
          this.rangeHourStorification = [
            [
              parseInt(minute)+2 >= 60 
                ? (parseInt(hour)+1 > 23 ? 0 : parseInt(hour)+1) 
                : parseInt(hour), 
              23
            ]
          ]
          this.rangeMinuteStorification = [
            [
              parseInt(minute)+2 >= 60 
                ? parseInt(minute)+2-60 
                : parseInt(minute)+2, 
              59
            ]
          ]
        }
        else {
          this.rangeHourStorification = [[0, 23]]
          this.rangeMinuteStorification = [[0, 59]]
        }
      }
    },

    changeRangeSchedulingTime(eventData) {
      const today = moment().hour(0).minute(0).second(0)
      if(today.unix() == moment(this.editValue.scheduling.date).hour(0).minute(0).second(0).unix()){
        if(parseInt(moment().hour()) < parseInt(eventData.data.HH))
          this.rangeMinute = [[0, 59]]
        else
          this.rangeMinute = [
            [
              moment().minute()+2 >= 60 
                ? `0${moment().minute()+2-60}` 
                : moment().minute()+2, 
              59
            ]
          ]
      }
    },

    changeRangeSchedulingTimeStorification(eventData) {
      let dateToCompare = moment(this.editValue.scheduling.date).hour(this.editValue.scheduling.time.HH).minute(this.editValue.scheduling.time.mm)
      if(moment(dateToCompare).hour(0).minute(0).second(0).unix() == moment(this.editValue.storification.date).hour(0).minute(0).second(0).unix()){
        if(parseInt(dateToCompare.hour()) < parseInt(eventData.data.HH))
          this.rangeMinuteStorification = [[0, 59]]
        else
          this.rangeMinuteStorification = [
            [
              parseInt(dateToCompare.minute())+2 >= 60 
                ? parseInt(dateToCompare.minute())+2-60 
                : parseInt(dateToCompare.minute())+2, 
              59
            ]
          ]
      }
    },

    showEditPost(field, commentId){      
      for(let indexField in this.activeEdit) {
        //save any changes
        if(this.activeEdit[indexField] && indexField != 'comment')
          this.$emit('editPostLive', this.page.id, indexField, this.editValue[indexField])
        
        //close all edit fields
        this.activeEdit[indexField] = false
      }
      //event to save&close changes on others previews
      this.$emit('currentPostLive', this.page.id, field)

      this.activeEdit[field] = true

      if ((field == 'snippet' || field == 'snippet_title') && this.page.network === 'facebook') {
        this.notify({
          title: this.$t('dash.post.overlay.edit.snippet'),
          text: this.$t('dash.posts.snippet.warning') + '<br><br><a href="https://www.facebook.com/business/help/321167023127050" target="_blank" style="color: #B38EA4; font-weight: bold">https://www.facebook.com/business/help</a>',
          color: 'primary',
          time: 10000,
          id: this.page.id
        })
        this.$forceUpdate();
      }

      if(field == 'scheduling') {
        if(moment(this.editValue.scheduling.date).isBefore(moment().add(2, 'minutes'))) {
          this.$set(this.editValue, 'scheduling', {
            date: moment().add(2, 'minutes').utc().local().format(),
            time: {
              HH: moment().add(2, 'minutes').utc().local().hour() < 10 
                                                  ? `0${moment().add(2, 'minutes').utc().local().hour()}`
                                                  : `${moment().add(2, 'minutes').utc().local().hour()}`,
              mm: moment().add(2, 'minutes').utc().local().minute() < 10 
                                                  ?`0${moment().add(2, 'minutes').utc().local().minute()}`
                                                  : `${moment().add(2, 'minutes').utc().local().minute()}`
            }
          })
        }
      }

      if (field === 'image') {
        let input = this.$refs.modifyImage;
        input.addEventListener('change', (e) => {
          let file = e.target.files[0];
          // this.$set(this.editValue, 'imageBase64', file);
          // this.$set(this.editValue, 'image', file);
          this.$emit('editPostLive', this.page.id, 'imageBase64', file)

          // const reader = new FileReader();
          // reader.onload = (e) => {
          //   this.$set(this.editValue, 'imageBase64', e.target.result);
          //   this.$emit('editPostLive', this.page.id, 'imageBase64', this.editValue['imageBase64'])
          // }
          // reader.readAsDataURL(file);
          
        });
        input.click();
      }

      if(field == 'comment') {
        if(!this.editValue[field][commentId])
          this.editValue[field][commentId] = this.post.page && this.post.page[0] && this.post.page[0].comments 
                                            ? this.post.page[0].comments.data[commentId]
                                            : this.post.comments[commentId]

        this.activeEdit[field] = commentId
      }

      if(!this.editValue[field] && !['scheduling', 'comment'].includes(field))
          this.editValue[field] = this.post[field]          
            
      let indexEdit = this.editPostValue.findIndex(p => p.page == this.page.id)
      if(field === 'title') {
        if(indexEdit >= 0 && this.editPostValue[indexEdit].title)
          this.$set(this.editValue, field, this.editPostValue[indexEdit].title)
        this.$nextTick(() => {
          this.textAreaAdjust(`inputTitle-${this.page.network_id}`)
        })
      }
      else if(field === 'comment') {
        if(indexEdit >= 0 && this.editPostValue[indexEdit].comment)
          this.$set(this.editValue, field, this.editPostValue[indexEdit].comment)
        this.$nextTick(() => {
          this.textAreaAdjust(`inputComment-${commentId}-${this.page.network_id}`)
        })
      }
    },

    editPost(field, storification, commentId){
      if(commentId != null && commentId >= 0)
        this.$emit('editPostLive', this.page.id, field, this.editValue.comment[commentId], null, commentId)
      else
        this.$emit('editPostLive', this.page.id, field, this.editValue[storification ? "storification" : field], storification)
      this.activeEdit[field] = false
    },

    removeComment(commentId){
      this.$emit('editPostLive', this.page.id, 'comment', false, null, commentId)
    },

    removeUrlInMessage() {
      this.editValue['removeUrlInMessage'] = !this.editValue['removeUrlInMessage']
      this.$emit('editPostLive', this.page.id, 'removeUrlInMessage', this.editValue['removeUrlInMessage'])
    },

    removeCustomized() {
      this.$emit('removeCustomized', this.page.id)
    },

    replaceByDefault(e) {
      e.target.src = imgDefault
      e.target.className = "error"
    },
    
    getHostName(url){
      return url && this.validURL(url) && new URL(url) ? new URL(url).hostname : null
    },

    validURL(str) {
      // var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      //   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      //   '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      //   '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      //   '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      //   '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      // return !!pattern.test(str);

      try {
        return Boolean(new URL(str)); 
      }
      catch(e){ 
        return false; 
      }
    },

    getMeta(){
      let url
      if(this.post.page && this.post.page[0] && this.post.page[0].news_url)
        url = this.post.page[0].news_url
      else if(this.post.url)
        url = this.post.url
      if(url) {
        let currentUrl = url
          if(this.post.page && this.post.page[0] && this.post.page[0].news_url)
            url = this.post.page[0].news_url
          else if(this.post.url)
            url = this.post.url

          if(currentUrl == url){
            this.showLoader = true
            this.getNewsMeta(url).then(res => {
              this.showLoader = false
              const { success, meta } = res.body

              if (!success || success !== true) { 
                return
              }
              this.meta = meta
            })
          }
      }
      else {
        this.meta = null
      }
    },
    async switchComment(postid, postis_comment_enable){
      this.$emit('switchComment', postid,postis_comment_enable)
    },
    
    dateFromNow(date){
      if(this.page.network == 'linkedin'){
        let temps = moment(date).fromNow(1)
        temps = temps.replace('heures', 'h')
        temps = temps.replace('heure', 'h')
        temps = temps.replace('jours', 'j')
        temps = temps.replace('jour', 'j')
        temps = temps.replace('un', '1')
        temps = temps.replace(/\s/g, '')
        return temps
        }
        else
          return moment(date).fromNow(0)    },

    dateFormat(date, story=null){
      if (story) {
        if (!["mois", "jour", "seconde", "minute", "heure"].some(e => date.includes(e))) {
          return date;
        }
        let unity = date.split(" ").pop()[0]
        let value = date.match(/\d+/g);
        value = value ? value[0] : "1"
        return value+unity
      }
      return moment(date).local(this.$i18n.locale).format('LLL')
    },

    isRemoveUrlInMessageToPost(){
      // let indexEdit = this.editPostValue ? this.editPostValue.findIndex(p => p.page == this.page.id) : -1
      let indexEdit = this.editPostValue ? this.editPostValue.findIndex(p => p.page == this.page.id) : null
      if(this.live){
        if(indexEdit >= 0 && this.editPostValue[indexEdit])
          return this.editPostValue[indexEdit].removeUrlInMessage
      }
      else if((this.post.page && this.post.page[0] && this.post.page[0].linkInComments) || (this.post.status == 'preview' && this.post._bots && this.post._bots[0] && this.post._bots[0].linkInComments))
        return true
      return (this.post.page && this.post.page[0] && this.post.page[0].removeUrlInMessage) || (this.editPostValue && this.editPostValue[indexEdit] && this.editPostValue[indexEdit].removeUrlInMessage)
      // return false
    },

    isPreviewLinkInComments(){
      return !this.live && ((this.post.page && this.post.page[0] && this.post.page[0].linkInComments) || (this.post.status == 'preview' && this.post._bots && this.post._bots[0] && this.post._bots[0].linkInComments))
    },

    getMessageToPost(post){
      if(this.live || this.showLive){
        let indexEdit = this.editPostValue.findIndex(p => p.page == this.page.id)
        if(this.editPostValue[indexEdit] && this.editPostValue[indexEdit].title)
          return this.editPostValue[indexEdit].title
      }

      if(this.live || (post.page && post.page.length && post.page[0].isManualPost))
        return post.title

      if(post._bots && post._bots[0]){
        switch(post._bots[0].post_text_layout){
          case 'title': 
            return post.title
          case 'description':
            return post.description || post.title
          case 'none':
            return ''
          default:
        }
      }
      else if(post._bots){
        switch(post._bots.post_text_layout){
          case 'title': 
            return post.title
          case 'description':
            return post.description || post.title
          case 'none':
            return ''
          default:
        }
      }
      if(this.page.network == 'pinterest'){
        if(post.title){
          let prefixLength = this.bot && this.bot.hashtagPrefix ? this.bot.hashtagPrefix.length : 0
          let suffixLength = this.bot && this.bot.hashtag ? this.bot.hashtag.length : 0
          if(post.title.length > 98 - (prefixLength + suffixLength)){
            if(post.title.charAt(92- (prefixLength + suffixLength)) != ' ' && post.title.charAt(93 - (prefixLength + suffixLength)) != ' ')
            {
              var posttitlecut = post.title.substring(0, (93 - (prefixLength + suffixLength)))
              var lastIndex = posttitlecut.lastIndexOf(" ")
              return posttitlecut.substring(0, lastIndex) + ' ...'
            }
            return post.title.substring(0, (93 - (prefixLength + suffixLength))) + ' ...'
          }
          else return post.title
        }
        else return post.title
      }
      else return post.title
    },

    getMessageToPostDescription(post){
      if(post._bots){
        switch(post._bots.post_text_layout){
          case 'description':
            return post.description
          case 'none':
            return ''
          default:
        }
      }
    if(post.description){
      if(post.description.length > 499) {
        if(post.description.charAt(495) != ' ' && post.description.charAt(496) != ' '){
          var postdescriptioncut = post.description.substring(0, 496)
          var lastIndex = postdescriptioncut.lastIndexOf(" ")
          return postdescriptioncut.substring(0, lastIndex) + ' ...'
        }
        return post.description.substring(0, 496) + ' ...'
      }
      else
      return post.description
    }
    return ''
    },

    addHashtagsLinks(str) {
      if(str){
        if(this.page.network == 'linkedin')
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.linkedin.com/feed/hashtag/?keywords=${match.replace('#', '')}" target="_blank">${match}</a>`});
        if(this.page.network == 'facebook')
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.facebook.com/hashtag/${match.replace('#', '')}" target="_blank">${match}</a>`});
        if(this.page.network == 'twitter')
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.twitter.com/hashtag/${match.replace('#', '')}" target="_blank">${match}</a>`});
        if(this.page.network == 'instagram')
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.instagram.com/explore/tags/${match.replace('#', '')}" target="_blank">${match}</a>`});
        
        //email links
        str = str.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/ig, "<a href='mailto:$1' target='_blank'>$1</a>");

        //retour à la ligne
        str = str.replace(/(?:\r\n|\r|\n)/g, '<br />')
      }
      return str
    },

    sizeCurrentMessage() {
      let message = this.handleNewLine(this.live && this.activeEdit.title ? this.editValue.title : this.getMessageToPost(this.post), true)
      if(this.page.network == 'twitter'){
        const twttr = require('twitter-text')
        return twttr.default.parseTweet(message).weightedLength
      }
      return message.length
    },

    limitText(){
      let limitText = null
      if(this.editValue.title && this.page.network == 'youtube') {
        limitText = 100
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'twitter') {
        // limitText = 280
        limitText = !this.page.story_config || this.page.story_config.verified_type == 'none' ? 280 : 25000
        if(this.post.url && !this.isRemoveUrlInMessageToPost())
          limitText = limitText - 23 - 1 //- 2

        // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
        // if(this.editValue.title.match(regexUrl))
        //   limitText = limitText - (23 * this.editValue.title.match(regexUrl).length)

        // // € or • counted as char*2
        // let regex = /€|•/gi
        // while (regex.exec(this.editValue.title)) 
        //   limitText--
        
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'bluesky') {
        limitText = 300
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'threads') {
        limitText = 500
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'google') {
        limitText = 1300
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'instagram') {
        limitText = 2200
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'linkedin') {
        limitText = 3000
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }
      else if(this.editValue.title && this.page.network == 'facebook') {
        limitText = 63206
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }
      }

      if(limitText && this.page.network != 'twitter' && ['image', 'video'].includes(this.typePost) && this.post.url && this.post.url != '')
        limitText = limitText - this.post.url.length

      return limitText
    },

    checkTruncate() {
      if(this.page.network == 'twitter') {
        // let limitText = 280
        let limitText = !this.page.story_config || this.page.story_config.verified_type == 'none' ? 280 : 25000
        if(this.post.url && !this.isRemoveUrlInMessageToPost())
          limitText = limitText - 23 - 1 //- 2

        // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
        // if(this.editValue.title.match(regexUrl))
        //   limitText = limitText - (23 * this.editValue.title.match(regexUrl).length)

        // // € counted as char*2
        // let regex = /€|•/gi
        // while (regex.exec(this.editValue.title)) 
        //   limitText--
         
        if(this.activePrefixSuffix){
          if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
            limitText = limitText - this.bot.hashtagPrefix.length - 1
          if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
            limitText = limitText - this.bot.hashtag.length - 1
        }

        // let messageLength = this.editValue.title.length
        // if(this.editValue.title.match(regexUrl))
        //   messageLength = this.editValue.title.length - this.editValue.title.match(regexUrl).reduce((previous, current) => previous + current.length, 0)
        
        const twttr = require('twitter-text')
        let messageLength = twttr.default.parseTweet(this.editValue.title).weightedLength

        this.textTruncated =  messageLength > limitText
        
      }
    },

    handleNewLine(str, withoutHtml=false, comment=false, description=false) {
      if(str && typeof str == 'string'){
        // {{...}} → valeur de la variable pour la page ciblée (vide si non renseignée), résolu
        // avant tout calcul de troncature par réseau ci-dessous.
        if(this.page && this.page.id) {
          str = resolveVariables(str, this.$store.getters['variables/getVariablesForPage'](this.page.id))
        }

        const checkUrlLength = (limitText) => {
          if(limitText && this.page.network != 'twitter' && ['image', 'video'].includes(this.typePost) && this.post.url && this.post.url != '')
            limitText = limitText - this.post.url.length
          return limitText
        }

        if(this.page.network == 'youtube' && !description){
          let limitText = 100

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'twitter'){
          // let limitText = 280
          let limitText = !this.page.story_config || this.page.story_config.verified_type == 'none' ? 280 : 25000
          if(this.post.url && !this.isRemoveUrlInMessageToPost())
            limitText = limitText - 23 - 1 //- 2

          // let regexUrl = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|[a-zA-Z\u00C0-\u017F0-9][a-zA-Z\u00C0-\u017F0-9-]+[a-zA-Z\u00C0-\u017F0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,}|www\.[a-zA-Z\u00C0-\u017F0-9]+\.[^\s]{2,})/g
          // if(str.match(regexUrl))
          //   limitText = limitText - (23 * str.match(regexUrl).length)

          // // € counted as char*2
          // let regex = /€|•/gi
          // while (regex.exec(str)) 
          //   limitText--
          
          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          // let messageLength = str.length
          // if(str.match(regexUrl))
          //   messageLength = str.length - str.match(regexUrl).reduce((previous, current) => previous + current.length, 0)
                                                 
          const twttr = require('twitter-text')
          let messageLength = twttr.default.parseTweet(str.trim()).weightedLength

          if(messageLength > limitText) {
            if(!withoutHtml) {
              // str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
              let limitTextTmp = limitText
              do {
                str = str.substr(0, str.substr(0, limitTextTmp - 4).lastIndexOf(" ")) + " ..."
                messageLength = twttr.default.parseTweet(str).weightedLength
                limitTextTmp--
              }
              while(messageLength > limitText)
            }
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'bluesky'){
          let limitText = 300

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'threads'){
          let limitText = 500

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'google'){
          let limitText = 1300

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'instagram'){
          let limitText = 2200

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'linkedin'){
          let limitText = 3000

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else if(this.page.network == 'facebook'){
          let limitText = 63206

          if(this.activePrefixSuffix && !comment){
            if(this.bot && this.bot.hashtagPrefix && this.bot.hashtagPrefix.length > 0)
              limitText = limitText - this.bot.hashtagPrefix.length - 1
            if(this.bot && this.bot.hashtag && this.bot.hashtag.length > 0)
              limitText = limitText - this.bot.hashtag.length - 1
          }

          limitText = checkUrlLength(limitText)

          if(str.length > limitText){
            if(!withoutHtml) 
              str = str.substr(0, str.substr(0, limitText - 4).lastIndexOf(" ")) + " ..."
            if(!comment) this.textTruncated = true
          }
          else {
            if(!comment) this.textTruncated = false
          }
        }
        else
          if(!comment) this.textTruncated = false

        //http links
        if(this.page.network != 'instagram' && !withoutHtml)
          str = str.replace(/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/ig, "<a href='$1' target='_blank'>$1</a>");
        
        //mentions
        if(this.activeMentionsAutoReplace && this.bot && this.bot.mentions && Array.isArray(this.bot.mentions)){        
          let regPonctuaction = "[.,!?:;\\-_]*"
          this.bot.mentions.forEach(mention => {
            mention.correspondences.some(correspondence => {
              if(str.toLowerCase().includes(correspondence.toLowerCase())){
                //insensitive case
                str = " "+str+" " //add start & end space 
                let mentionPrefix = ['twitter', 'instagram', 'bluesky'].includes(this.page.network) ? "@" : "@["
                let mentionSuffix = ['twitter', 'instagram', 'bluesky'].includes(this.page.network) ? "" : "]"
                
                let reg = new RegExp(` ${regPonctuaction}${correspondence}${regPonctuaction} `, 'gi')
                let reg2 = new RegExp(correspondence, 'i')
                let match = reg.exec(str)
                if (match) {
                  //if need space before and/or after corespondence
                  let change = mentionPrefix+mention.mention+mentionSuffix
                  let match2 = new RegExp("[.,!?:;\\-_]", 'gi').exec(match[0])
                  if(match2){
                    if(match2 && match2.index > 1) change = change+' '
                    else if(match2) change = ' '+change
                  }
                  str = str.replace(reg2, change)
                  str = str.slice(1, str.length-1) //remove start & end space 
                  str = str.replace("@@", "@")
                }

                return true
              }
            })
          })
        }
        const getUrlHashtag = (hashtag) => {
          switch(this.page.network){
            case 'linkedin': return 'https://www.linkedin.com/feed/hashtag/?keywords=' + hashtag //https://www.linkedin.com/feed/hashtag/?keywords=jeunes
            case 'facebook': return 'https://www.facebook.com/hashtag/' + hashtag //https://www.facebook.com/hashtag/extr%C3%AAmedroite
            case 'twitter': return 'https://www.twitter.com/hashtag/' + hashtag // https://twitter.com/hashtag/Rediff
            case 'instagram': return 'https://www.instagram.com/explore/tags/' + hashtag // https://www.instagram.com/explore/tags/basket/
            default: return ''
          }
        }
        //find & replace @hashtagsAuto
        if(this.activeHashtagsAutoAdd && this.bot && this.bot.hashtagsAuto && Array.isArray(this.bot.hashtagsAuto)){
          let regPonctuaction = "[.,!?:;\\-_]*"
          this.bot.hashtagsAuto.forEach(hashtagAuto => {
            hashtagAuto.correspondences.some(correspondence => {
              if(str.toLowerCase().includes(correspondence.toLowerCase())){
                //insensitive case
                str = " "+str+" " //add start & end space 
                                
                let reg = new RegExp(` ${regPonctuaction}${correspondence}${regPonctuaction} `, 'gi')
                let reg2 = new RegExp(correspondence, 'i')
                let match = reg.exec(str)
                if (match) {
                  //if need space before and/or after corespondence
                  let change = ` <a href="${getUrlHashtag(hashtagAuto.hashtag)}" target="_blank">#${hashtagAuto.hashtag}</a>`
                  if(withoutHtml) change = ` #${hashtagAuto.hashtag}`
                  let match2 = new RegExp("[.,!?:;\\-_]", 'gi').exec(match[0])
                  if(match2){
                    if(match2 && match2.index > 1) change = change+' '
                    else if(match2) change = ' '+change
                  }
                  str = str.replace(reg2, change)
                  str = str.slice(1, str.length-1) //remove start & end space 
                  str = str.replace("##", "#")
                }
                return true
              }
            })
          })
        }

        const getUrlMention = (mention) => {
          //console.log(mention);
          switch(mention.network){
            case 'linkedin': {
              let regex = /.*\((.+)\)/;
              let match = regex.exec(mention.value);
              if(match && match.length > 1){
                if (!isNaN(match[1])) 
                  return 'https://www.linkedin.com/company/' + match[1]
                else
                  return 'https://www.linkedin.com/in/' + match[1]
              }
              return 'https://www.linkedin.com/company/' + mention.value.substring(2, mention.value.indexOf(' ('))
            }
            case 'facebook': return 'https://www.facebook.com/' + mention.value.substring(mention.value.indexOf('(') + 1, mention.value.indexOf(')'))
            case 'twitter': return 'https://www.twitter.com/' + mention.value.replace('@', '')
            case 'instagram': return 'https://www.instagram.com/' + mention.value.replace('@', '')
            case 'bluesky': return 'https://bsky.app/profile/' + mention.value.replace('@', '')
            default: return ''
          }
        }
        
        //replace multi-mention
        let maxWhile = 100
        let countWhile = 0
        while(str.includes('@[MENTIONS-') && countWhile<maxWhile){
          countWhile++
          let start = str.indexOf('@[MENTIONS-')
          let end = str.indexOf(']', start)
          let index = parseInt(str.substr(start, end+1).replace('@[MENTIONS-', '').replace(']', ''))
          if(!this.validMentions || !this.validMentions[index-1]) break
          let mention = this.validMentions[index-1].find(m => m.network == this.page.network)
          let mentionTmp
          if(mention && mention.value) 
            switch(mention.network){
              case 'twitter':
              case 'instagram':
              case 'bluesky':
                mentionTmp = `<a href="${getUrlMention(mention)}" target="_blank">${mention.value.trim()}</a>`
                if(withoutHtml) mentionTmp = mention.value.trim()
                mention = mentionTmp
                break
              case 'facebook':
              case 'linkedin':
                mentionTmp = `<a href="${getUrlMention(mention)}" target="_blank">${mention.value.substring(2, mention.value.indexOf('(')).trim()}</a>`
                if(withoutHtml) mentionTmp = mention.value.substring(2, mention.value.indexOf('(')).trim()
                mention = mentionTmp
                break
              default:
            }
          else if(mention && mention.word){
              mention = mention.word
          }
          str = str.substr(0, start) + (mention ? mention : this.validMentions[index-1][0].word) + str.substr(end+1)
        }

        //replace mention affected
        countWhile = 0
        while(str.includes('@[') && countWhile<maxWhile){
          countWhile++
          let start = str.indexOf('@[')
          let end = str.indexOf(']', start)
          let mention = {
            network: this.page.network,
            value: str.substr(start, end-start+1)
          }
          if(mention.value.includes('@[MENTIONS-]')) mention = null
          if(mention && mention.value && mention.value != '') {
            let mentionTmp
            switch(mention.network){
              case 'twitter':
              case 'instagram':
              case 'bluesky':
                mentionTmp = `<a href="${getUrlMention(mention)}" target="_blank">${mention.value.trim()}</a>`
                if(withoutHtml) mentionTmp = mention.value.trim()
                mention = mentionTmp
                break
              case 'facebook':
              case 'linkedin':
                mentionTmp = `<a href="${getUrlMention(mention)}" target="_blank">${mention.value.substring(2, mention.value.indexOf('(')).trim()}</a>`
                if(withoutHtml) mentionTmp = mention.value.substring(2, mention.value.indexOf('(')).trim()
                mention = mentionTmp
                break
              default:
            }
            str = str.substr(0, start) + (mention ? mention : '') + str.substr(end+1)
          }
        }

        //replace all manual mention link (twitter & instagram & bluesky)
        if(this.page.network == 'twitter' && !withoutHtml) 
          str = ` ${str} `.replace(/@[a-zA-Z0-9._-]* /ig, function replace(match) { return match.includes('@[') ? match : `<a href="https://twitter.com/${match.replace('@', '').trim()}" target="_blank">${match}</a>`}).trim();
        else if(this.page.network == 'instagram' && !withoutHtml)         
          str = ` ${str} `.replace(/@[a-zA-Z0-9._-]* /ig, function replace(match) { return match.includes('@[') ? match : `<a href="https://www.instagram.com/${match.replace('@', '').trim()}" target="_blank">${match}</a>`}).trim();
        else if(this.page.network == 'bluesky' && !withoutHtml)         
          str = ` ${str} `.replace(/@[a-zA-Z0-9._-]* /ig, function replace(match) { return match.includes('@[') ? match : `<a href="https://bsky.app/profile/${match.replace('@', '').trim()}" target="_blank">${match}</a>`}).trim();

        str = ` ${str} `.replace(' null ', ' <span class="problem">null</span> ').trim()   
             
        //replace all manual hashtag by link
        if(this.page.network == 'linkedin' && !withoutHtml)
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.linkedin.com/feed/hashtag/?keywords=${match.replace('#', '')}" target="_blank">${match}</a>`});
        if(this.page.network == 'facebook' && !withoutHtml)
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.facebook.com/hashtag/${match.replace('#', '')}" target="_blank">${match}</a>`});
        if(this.page.network == 'twitter' && !withoutHtml)
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.twitter.com/hashtag/${match.replace('#', '')}" target="_blank">${match}</a>`});
        if(this.page.network == 'instagram' && !withoutHtml)
         str = str.replace(/#[\u00C0-\u017Fa-zA-Z0-9._-]+/ig, function replace(match) { return `<a href="https://www.instagram.com/explore/tags/${match.replace('#', '')}" target="_blank">${match}</a>`});
        
        //replace multi-hashtags
        countWhile = 0
        while(str.includes('#[HASHTAGS-') && countWhile<maxWhile){
          countWhile++
          let start = str.indexOf('#[HASHTAGS-')
          let end = str.indexOf(']', start)
          let index = parseInt(str.substr(start, end+1).replace('#[HASHTAGS-', '').replace(']', ''))
          if(!this.validHashtags[index-1]) break
          let mention = this.validHashtags[index-1].find(m => m.network == this.page.network)
          let mentionTmp
          if(mention && mention.value) 
            switch(mention.network){
              case 'twitter':
                mentionTmp = `<a href="https://www.twitter.com/hashtag/${mention.value}" target="_blank">${mention.value}</a>`
                if(withoutHtml) mentionTmp = mention.value
                mention = mentionTmp
                break
              case 'instagram':
                mentionTmp = `<a href="https://www.instagram.com/explore/tags/${mention.value}" target="_blank">${mention.value}</a>`
                if(withoutHtml) mentionTmp = mention.value
                mention = mentionTmp
                break
              default:
          }
          else if(mention && mention.word){
              mention = `#${mention.word}`
          }
          str = str.substr(0, start) + (mention ? mention : `#${this.validHashtags[index-1][0].word}`) + str.substr(end+1)
        }
        
        //email links
        if(!withoutHtml)
          str = str.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/ig, "<a href='mailto:$1' target='_blank'>$1</a>");

        return withoutHtml ? str : str.replace(/(?:\r\n|\r|\n)/g, '<br />');
      }
      else return str
    },

    getIndicesOf(searchStr, str, caseSensitive) {
      var searchStrLen = searchStr.length;
      if (searchStrLen == 0) {
          return [];
      }
      var startIndex = 0, index, indices = [];
      if (!caseSensitive) {
          str = str.toLowerCase();
          searchStr = searchStr.toLowerCase();
      }
      let maxWhile = 100
      let countWhile = 0
      while ((index = str.indexOf(searchStr, startIndex)) > -1 && countWhile<maxWhile) {
        countWhile++
        indices.push(index);
        startIndex = index + searchStrLen;
      }
      return indices;
    },

  },

  computed: {

    imageStory() {
      if (this.post.draft && this.post.draft.data && this.post.draft.data.form && this.post.draft.data.form.video) {
        return this.post.draft.data.form.enclosure;
      }
      if (this.post.page && this.post.page[0] && this.post.page[0].draft) {
        let draft = JSON.parse(this.post.page[0].draft);
        if (draft.form && draft.form.enclosure) {
          return draft.form.enclosure
        }
      }
      return (this.carouselData && this.carouselData[0] && this.carouselData[0].url) || this.post.enclosure || this.image || (this.meta && this.meta.og && this.meta.og.image) || (this.meta && this.meta.og && this.meta.og.images && this.meta.images[0] && this.meta.images[0].url) ||  (this.meta && this.meta.images && this.meta.images[0] && this.meta.images[0].url)
    },

    videoStory() {
      if (this.post.draft && this.post.draft.data && this.post.draft.data.form && this.post.draft.data.form.video) {
        return this.post.draft.data.form.video;
      }
      if (this.post.page && this.post.page[0] && this.post.page[0].draft) {
        let draft = JSON.parse(this.post.page[0].draft);
        if (draft.form && draft.form.video) {
          return draft.form.video
        } else if (draft.videos && (draft.videos['instagram'] || draft.videos['story'])) {
          return draft.videos['instagram'] || draft.videos['story'];
        }
      }
      // if (this.post.page && this.post.page[0] && this.post.page[0].enclosure && this.post.page[0].enclosure.endsWith('.mp4')) {
      //   return this.post.page[0].enclosure;
      // }
      if (this.post.status === 'scheduled' && this.imageStory) {
        return null;
      }
      return this.post.video || (this.post.videos && (this.post.videos[this.page.network] || this.post.videos['story'])) || (this.post.page && this.post.page[0] && this.post.page[0].video)
    },

    shareAfterPostPreview() {
      return this.post && (this.post.data && this.post.data.shareAfterPost) || (this.post.draf && this.post.draft.data && this.post.draft.data.shareAfterPost) || (this.post.page && this.post.page.length && this.post.page[0].storification) || (this.post.page && this.post.page[0] && this.post.page[0].story && this.post.original && this.post.original_news)
    },

    currentBot() {
      if (!localStorage.bots || !this.bot) return null;
      return JSON.parse(localStorage.bots).find(b => b.id == this.bot.id)
    },

    needCompress() {
      let minSize = this.page.network === 'google' ? 10240 : 0;
      let maxSize = ['google', 'twitter'].includes(this.page.network) ? 5000000 : (this.page.network === 'instagram' ? 8000000 : (this.page.network === 'facebook' ? 4000000 : Infinity))
      if (!this.multipleImages || !this.multipleImages[0]) {
        return [];
      }
      let ok =  !!(this.typePost === 'image' && this.multipleImages && this.multipleImages[0] && this.multipleImages[0].file)
      if (ok) {
        if ((this.multipleImages[0].file && this.multipleImages[0].file.type && this.multipleImages[0].file.type.includes('gif')) || (this.multipleImages[0].ext === 'gif')) return [];
        return this.multipleImages.filter(e => (e.file && e.file.size && (minSize > e.file.size || maxSize < e.file.size)) || (e.size && (minSize > e.size || maxSize < e.size))).map(e => e.id)
      }
      return [];
      // return this.typePost === 'image' && this.multipleImages && this.multipleImages[0] && this.multipleImages[0].file && this.multipleImages[0].file.size && (minSize > this.multipleImages[0].file.size || maxSize < this.multipleImages[0].file.size);
    },

    activeSearchHashtags() {
      return ['twitter', 'instagram'].includes(this.page.network)
    },

    storyPollValue() {
      if (!this.post.page[0] || !this.post.page[0].story) return null;
      let story = JSON.parse(this.post.page[0].story);
      if (this.post.status !== 'scheduled') {
        if (!story.poll) return null;
        let currentpoll = {...story.poll, x: (story.poll.x/1440)*320, y: (story.poll.y/2560)*569};
        return currentpoll;
      }
      return story.texts[0].poll ? JSON.parse(story.texts[0].poll) : null;
    },

    pollValue(){
      if (this.post && this.post.page && this.post.page[0] && this.post.page[0].poll)
        return typeof this.post.page[0].poll == 'string' ? JSON.parse(this.post.page[0].poll) : this.post.page[0].poll
      else return this.poll;
    },

    pollDuration(){
      switch (this.pollValue.duration) {
        case '86400': return this.$t('dash.post.poll.duration.option1');
        case '259200': return this.$t('dash.post.poll.duration.option2');
        case '604800': return this.$t('dash.post.poll.duration.option3');
        case '1209600': return this.$t('dash.post.poll.duration.option4');
        default: return this.$t('dash.post.poll.duration.option3');
      }
    },
    
    carouselPreview() {
      if (this.page.network === 'twitter') {
        if (this.carouselData.filter(e => e.file).length === 3) {
          return this.carouselData.filter(e => e.file).sort((e1, e2) => e1.twitter - e2.twitter).slice(0,4).reverse();
        } else {
          return this.carouselData.filter(e => e.file).sort((e1, e2) => e1.twitter - e2.twitter).slice(0,4);
        }
      } else if (this.page.network === 'linkedin') {
        if (this.carouselData.filter(e => e.file).length > 2) {
          return this.carouselData.filter(e => e.file).sort((e1, e2) => e1.linkedin - e2.linkedin).slice(0,5).reverse();
        } else {
          return this.carouselData.filter(e => e.file).sort((e1, e2) => e1.linkedin - e2.linkedin).slice(0,5);
        }
      } else if (this.page.network === 'facebook') {
        if (this.carouselData.filter(e => e.file).length === 3) {
          return this.carouselData.filter(e => e.file).sort((e1, e2) => e1.facebook - e2.facebook).slice(0,4).reverse();
        } else {
          return this.carouselData.filter(e => e.file).sort((e1, e2) => e1.facebook - e2.facebook).slice(0,4);
        }
        
      }
      return this.carouselData.filter(e => e.file);
    },

    carouselData() {
       if (['instagram', 'linkedin', 'facebook', 'twitter', 'threads'].includes(this.page.network) && this.typePost === 'image' && this.multipleImagesPreview && this.multipleImagesPreview.length > 0 && this.multipleImagesPreview[0].file) {
        return this.multipleImagesPreview;
        // return this.carouselOrder;
      } else if (this.post && this.post.page && this.post.page[0] && this.post.page[0].carousel) {
        return this.post.page[0].carousel;
      }
      return null;
    },

    postDateStorification(){
      let indexEdit = this.editPostValue ? this.editPostValue.findIndex(p => p.page == this.page.id) : null
      if(this.post.status === 'preview' && this.post.preview_date)
        return this.dateFormat(this.post.preview_date)
      if(this.post.status === 'posted' && this.post.posted_date)
        return this.dateFromNow(this.post.posted_date)
      if(this.post.status === 'scheduled' && this.post.scheduled_date)
        return this.dateFormat(this.post.scheduled_date)
      if(this.post.status === 'failed' && this.post.scheduled_date)
        return this.dateFromNow(this.post.scheduled_date)
      if(indexEdit >= 0 && this.editPostValue && this.editPostValue[indexEdit] && this.editPostValue[indexEdit].storification)
        return this.dateFormat(moment(this.editPostValue[indexEdit].storification.date)
                                .hours(this.editPostValue[indexEdit].storification.time.HH)
                                .minutes(this.editPostValue[indexEdit].storification.time.mm))
      else if(this.schedulingOverlay && this.schedulingOverlay.show) 
        return this.dateFormat(moment(this.schedulingOverlay.date)
                                .hours(this.schedulingOverlay.time.HH)
                                .minutes(this.schedulingOverlay.time.mm))
      else
        return this.$t('dash.preview.date.now')
    },

    postDate(){
      let indexEdit = this.editPostValue ? this.editPostValue.findIndex(p => p.page == this.page.id) : null
      if(this.post.status === 'preview' && this.post.preview_date)
        return this.dateFormat(this.post.preview_date)
      if(this.post.status === 'posted' && this.post.posted_date)
        return this.dateFromNow(this.post.posted_date)
      if(this.post.status === 'scheduled' && this.post.scheduled_date)
        return this.dateFormat(this.post.scheduled_date)
      if(this.post.status === 'failed' && this.post.scheduled_date)
        return this.dateFromNow(this.post.scheduled_date)
      if(indexEdit >= 0 && this.editPostValue && this.editPostValue[indexEdit] && this.editPostValue[indexEdit].scheduling)
        return this.dateFormat(moment(this.editPostValue[indexEdit].scheduling.date)
                                .hours(this.editPostValue[indexEdit].scheduling.time.HH)
                                .minutes(this.editPostValue[indexEdit].scheduling.time.mm))
      else if(this.schedulingOverlay && this.schedulingOverlay.show) 
        return this.dateFormat(moment(this.schedulingOverlay.date)
                                .hours(this.schedulingOverlay.time.HH)
                                .minutes(this.schedulingOverlay.time.mm))
      else
        return this.$t('dash.preview.date.now')
    },

    localStorage() {
      return localStorage;
    },

    instagramTexts() {
      let instaTxt = [];
      let y = 100;
      if (!this.post.page[0] || !this.post.page[0].story) {
        instaTxt.push({
          content: this.post.title,
          x: 150,
          y,
          color: 'white',
          background: 'black',
          size: 15,
          font: 1,
          angle: 0,
        })
        return instaTxt;
      }
      let storyObject = JSON.parse(this.post.page[0].story)
      if (!Array.isArray(storyObject)) {
        storyObject = [storyObject];
      }
      for (let txt of storyObject) {
        let x = ((parseInt(txt.position.x) * 300) / 1440);
        let y = ((parseInt(txt.position.y) * 532) / 2560);
        instaTxt.push({
          content: txt.text,
          x: x,
          y: y,
          color: txt.color,
          background: txt.textFond,
          size: txt.size ? txt.size *0.5 : 15,
          font: txt.font ? txt.font : 1,
          angle: txt.angle ? txt.angle : 0,
        })
      }
      return instaTxt;
    },
    
    getPageUrl() {
      switch(this.page.network){
        case 'facebook': 
          return `https://www.facebook.com/${this.page.network_id}`
        case 'twitter': 
          return `https://twitter.com/${this.page.name}`
        case 'linkedin':
          if(/^[0-9]+$/.test(this.page.network_id) == false && this.linkedinVanityName)
            return `https://www.linkedin.com/in/${this.linkedinVanityName}`
          return /^[0-9]+$/.test(this.page.network_id) ? `https://www.linkedin.com/company/${this.page.network_id}` : ''
        case 'instagram': 
          return `https://www.instagram.com/${this.page.name}`
        case 'pinterest':
          return `https://www.pinterest.com/${this.page.name}`
        case 'google':
          return `https://business.google.com/n/${this.page.network_id.replace('locations/', '')}/profile`
        case 'youtube':
          return `https://youtube.com/${this.page.name}`
        case 'threads':
          return `https://www.threads.net/@${this.page.name}`
        case 'bluesky':
          return `https://bsky.app/profile/${this.page.name}`
        default:
            return ''
      }
    },

    postURL() {
      return this.post.url;
    },

    postVideo() {
      return this.post.video;
    },

    getUrlWithUtm(){
      if (!!this.post.url && !!this.post.url.trim().length) {
        if(this.bot && this.bot.utm_source){
          // Add UTM params to URL
          const newsUrl = new URL(this.post.url)
          const utmParams = new URLSearchParams(this.bot.utm_source)
          for (const [k, v] of utmParams) {
            newsUrl.searchParams.set(k, v)
          }
          return newsUrl.href
        }
        else return this.post.url
      }
    },
    
    firstImageAspectRatio() {
      let ratio = "auto";
      if (this.carouselData && this.carouselData.length > 0) {
        let img = new Image();
        img.src = this.carouselData[0].url
        ratio = `${img.width} / ${img.height}`;
      }
      return ratio;
    }
  },

  watch: {

    multipleImages(val) {
      console.log("Change multiple image", val);
      this.multipleImagesPreview = val.map(e => {
        let fileTemp = new File([e.file], e.file.name, { type: e.file.type } );
        let copy = JSON.parse(JSON.stringify(e));
        copy.file = fileTemp;
        return copy;
      })
      // this.multipleImagesPreview = JSON.parse(JSON.stringify(val));
    },

    image() {
      if (this.typePost === "document") {
        this.pdfReset = false;
        this.$forceUpdate()
        setTimeout(_=>{
          this.pdfReset = true;
          this.$forceUpdate()
        }, 10)
      }
      
    },
    post() {
      this.bot = this.post && this.post._bots && this.post._bots.page && this.post._bots.page.id == this.page.id 
                              ? this.post._bots 
                              : (this.post && this.post._bots && this.post._bots[0] && this.post._bots[0].page && this.post._bots[0].page.id == this.page.id
                                      ? this.post._bots[0]
                                      : JSON.parse(localStorage.bots).find(b => b.page.id == this.page.id))
    },

    postURL() {
      this.getMeta()
    },
    
    page() {
      this.bot = JSON.parse(localStorage.bots).find(b => b.page.id == this.page.id)
    },

    editPostValue() {
      let indexEdit = this.editPostValue.findIndex(p => p.page == this.page.id)
      if(indexEdit >= 0) {
        for(let indexField in this.editPostValue[indexEdit]) {
          if(this.editPostValue[indexEdit] && this.editPostValue[indexEdit][indexField])
            this.editValue[indexField] = this.editPostValue[indexEdit][indexField]
          else if(indexField == 'title')
            this.editValue.title = this.currentPostFieldEdit.page == this.page.id ? this.post.title : null
        }
      }
      else 
        this.editValue = {
          storification: {
            date: moment().add(2, 'minutes').second(0).utc().local().format(),
            time: {
              HH: moment().add(2, 'minutes').utc().local().hour() < 10 
                                      ? `0${moment().add(2, 'minutes').utc().local().hour()}`
                                      : `${moment().add(2, 'minutes').utc().local().hour()}`,
              mm: moment().add(2, 'minutes').utc().local().minute() < 10 
                                      ?`0${moment().add(2, 'minutes').utc().local().minute()}`
                                      : `${moment().add(2, 'minutes').utc().local().minute()}`
            }
          },
          title: null,
          scheduling: {
            date: moment().add(2, 'minutes').second(0).utc().local().format(),
            time: {
              HH: moment().add(2, 'minutes').utc().local().hour() < 10 
                                      ? `0${moment().add(2, 'minutes').utc().local().hour()}`
                                      : `${moment().add(2, 'minutes').utc().local().hour()}`,
              mm: moment().add(2, 'minutes').utc().local().minute() < 10 
                                      ?`0${moment().add(2, 'minutes').utc().local().minute()}`
                                      : `${moment().add(2, 'minutes').utc().local().minute()}`
            }
          },
          comment: {}
        }
    },

    previewEdited() {
      if(!this.previewEdited) {
        this.activeEdit.title = false
        this.editValue.title = null
      }
    },

    currentPostFieldEdit() {
      if(this.currentPostFieldEdit.page != this.page.id){
        for(let indexField in this.activeEdit) {
          //save any changes
          if(this.activeEdit[indexField])
            this.$emit('editPostLive', this.page.id, indexField, this.editValue[indexField])
          //close all edit fields
          this.activeEdit[indexField] = false
        }
      }
    }
  }
}    
</script>

<style scoped>

.styles-text-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 10px;
  left: 40%;
  flex-direction: row;
}

.styles-text-buttons > span {
  position: static;
  width: 30px;
  margin-right: 3px;
}

.textarea-emoji-picker {
  position: relative;
  margin: 0 auto;
  clear: both;
}
.textarea {
  width: 100%;
  min-height: 300px;
  outline: none;
  box-shadow: none;
  padding: 10px 28px 10px 10px;
  font-size: 15px;
  border: 1px solid #BABABA;
  color: #333;
  border-radius: 2px;
  box-shadow: 0px 2px 4px 0 rgba(0,0,0,0.1) inset;
  resize: vertical;
}
.emoji-mart {
  position: absolute;
  top: 0px;
  right: calc(-100% + 45px);
  z-index: 8;
  right: 0;
}
.emoji-trigger {
  position: absolute;
  bottom: 10px;
  right: 20px;
  cursor: pointer;
  height: 20px;
  z-index: 1;
}
.emoji-trigger path {
  transition: 0.1s all;
}
.emoji-trigger {
  background: #fff;
  border-radius: 7px;
  width: 33px;
  height: 33px;
  padding: 6px 5px;
}
.emoji-trigger:hover,
.emoji-trigger.triggered {
  background: #6a1f4c;
}
.emoji-trigger path {
  fill: #6a1f4c;
}
.emoji-trigger:hover path,
.emoji-trigger.triggered path {
  fill: #fff;
}
</style>